
import { isNullOrWhiteSpace, join } from "../fable-library-js.5.3.0/String.js";
import { filter } from "../fable-library-js.5.3.0/List.js";

/**
 * Combines multiple Tailwind class names into a single string
 */
export function tw(classes) {
    return join(" ", filter((arg) => !isNullOrWhiteSpace(arg), classes));
}

export const backgroundColor_bgInherit = "bg-inherit";

export const backgroundColor_bgCurrent = "bg-current";

export const backgroundColor_bgTransparent = "bg-transparent";

export const backgroundColor_bgBlack = "bg-black";

export const backgroundColor_bgWhite = "bg-white";

export const backgroundColor_bgSlate50 = "bg-slate-50";

export const backgroundColor_bgSlate100 = "bg-slate-100";

export const backgroundColor_bgSlate200 = "bg-slate-200";

export const backgroundColor_bgSlate300 = "bg-slate-300";

export const backgroundColor_bgSlate400 = "bg-slate-400";

export const backgroundColor_bgSlate500 = "bg-slate-500";

export const backgroundColor_bgSlate600 = "bg-slate-600";

export const backgroundColor_bgSlate700 = "bg-slate-700";

export const backgroundColor_bgSlate800 = "bg-slate-800";

export const backgroundColor_bgSlate900 = "bg-slate-900";

export const backgroundColor_bgSlate950 = "bg-slate-950";

export const backgroundColor_bgGray50 = "bg-gray-50";

export const backgroundColor_bgGray100 = "bg-gray-100";

export const backgroundColor_bgGray200 = "bg-gray-200";

export const backgroundColor_bgGray300 = "bg-gray-300";

export const backgroundColor_bgGray400 = "bg-gray-400";

export const backgroundColor_bgGray500 = "bg-gray-500";

export const backgroundColor_bgGray600 = "bg-gray-600";

export const backgroundColor_bgGray700 = "bg-gray-700";

export const backgroundColor_bgGray800 = "bg-gray-800";

export const backgroundColor_bgGray900 = "bg-gray-900";

export const backgroundColor_bgGray950 = "bg-gray-950";

export const backgroundColor_bgZinc50 = "bg-zinc-50";

export const backgroundColor_bgZinc100 = "bg-zinc-100";

export const backgroundColor_bgZinc200 = "bg-zinc-200";

export const backgroundColor_bgZinc300 = "bg-zinc-300";

export const backgroundColor_bgZinc400 = "bg-zinc-400";

export const backgroundColor_bgZinc500 = "bg-zinc-500";

export const backgroundColor_bgZinc600 = "bg-zinc-600";

export const backgroundColor_bgZinc700 = "bg-zinc-700";

export const backgroundColor_bgZinc800 = "bg-zinc-800";

export const backgroundColor_bgZinc900 = "bg-zinc-900";

export const backgroundColor_bgZinc950 = "bg-zinc-950";

export const backgroundColor_bgNeutral50 = "bg-neutral-50";

export const backgroundColor_bgNeutral100 = "bg-neutral-100";

export const backgroundColor_bgNeutral200 = "bg-neutral-200";

export const backgroundColor_bgNeutral300 = "bg-neutral-300";

export const backgroundColor_bgNeutral400 = "bg-neutral-400";

export const backgroundColor_bgNeutral500 = "bg-neutral-500";

export const backgroundColor_bgNeutral600 = "bg-neutral-600";

export const backgroundColor_bgNeutral700 = "bg-neutral-700";

export const backgroundColor_bgNeutral800 = "bg-neutral-800";

export const backgroundColor_bgNeutral900 = "bg-neutral-900";

export const backgroundColor_bgNeutral950 = "bg-neutral-950";

export const backgroundColor_bgStone50 = "bg-stone-50";

export const backgroundColor_bgStone100 = "bg-stone-100";

export const backgroundColor_bgStone200 = "bg-stone-200";

export const backgroundColor_bgStone300 = "bg-stone-300";

export const backgroundColor_bgStone400 = "bg-stone-400";

export const backgroundColor_bgStone500 = "bg-stone-500";

export const backgroundColor_bgStone600 = "bg-stone-600";

export const backgroundColor_bgStone700 = "bg-stone-700";

export const backgroundColor_bgStone800 = "bg-stone-800";

export const backgroundColor_bgStone900 = "bg-stone-900";

export const backgroundColor_bgStone950 = "bg-stone-950";

export const backgroundColor_bgRed50 = "bg-red-50";

export const backgroundColor_bgRed100 = "bg-red-100";

export const backgroundColor_bgRed200 = "bg-red-200";

export const backgroundColor_bgRed300 = "bg-red-300";

export const backgroundColor_bgRed400 = "bg-red-400";

export const backgroundColor_bgRed500 = "bg-red-500";

export const backgroundColor_bgRed600 = "bg-red-600";

export const backgroundColor_bgRed700 = "bg-red-700";

export const backgroundColor_bgRed800 = "bg-red-800";

export const backgroundColor_bgRed900 = "bg-red-900";

export const backgroundColor_bgRed950 = "bg-red-950";

export const backgroundColor_bgOrange50 = "bg-orange-50";

export const backgroundColor_bgOrange100 = "bg-orange-100";

export const backgroundColor_bgOrange200 = "bg-orange-200";

export const backgroundColor_bgOrange300 = "bg-orange-300";

export const backgroundColor_bgOrange400 = "bg-orange-400";

export const backgroundColor_bgOrange500 = "bg-orange-500";

export const backgroundColor_bgOrange600 = "bg-orange-600";

export const backgroundColor_bgOrange700 = "bg-orange-700";

export const backgroundColor_bgOrange800 = "bg-orange-800";

export const backgroundColor_bgOrange900 = "bg-orange-900";

export const backgroundColor_bgOrange950 = "bg-orange-950";

export const backgroundColor_bgAmber50 = "bg-amber-50";

export const backgroundColor_bgAmber100 = "bg-amber-100";

export const backgroundColor_bgAmber200 = "bg-amber-200";

export const backgroundColor_bgAmber300 = "bg-amber-300";

export const backgroundColor_bgAmber400 = "bg-amber-400";

export const backgroundColor_bgAmber500 = "bg-amber-500";

export const backgroundColor_bgAmber600 = "bg-amber-600";

export const backgroundColor_bgAmber700 = "bg-amber-700";

export const backgroundColor_bgAmber800 = "bg-amber-800";

export const backgroundColor_bgAmber900 = "bg-amber-900";

export const backgroundColor_bgAmber950 = "bg-amber-950";

export const backgroundColor_bgYellow50 = "bg-yellow-50";

export const backgroundColor_bgYellow100 = "bg-yellow-100";

export const backgroundColor_bgYellow200 = "bg-yellow-200";

export const backgroundColor_bgYellow300 = "bg-yellow-300";

export const backgroundColor_bgYellow400 = "bg-yellow-400";

export const backgroundColor_bgYellow500 = "bg-yellow-500";

export const backgroundColor_bgYellow600 = "bg-yellow-600";

export const backgroundColor_bgYellow700 = "bg-yellow-700";

export const backgroundColor_bgYellow800 = "bg-yellow-800";

export const backgroundColor_bgYellow900 = "bg-yellow-900";

export const backgroundColor_bgYellow950 = "bg-yellow-950";

export const backgroundColor_bgLime50 = "bg-lime-50";

export const backgroundColor_bgLime100 = "bg-lime-100";

export const backgroundColor_bgLime200 = "bg-lime-200";

export const backgroundColor_bgLime300 = "bg-lime-300";

export const backgroundColor_bgLime400 = "bg-lime-400";

export const backgroundColor_bgLime500 = "bg-lime-500";

export const backgroundColor_bgLime600 = "bg-lime-600";

export const backgroundColor_bgLime700 = "bg-lime-700";

export const backgroundColor_bgLime800 = "bg-lime-800";

export const backgroundColor_bgLime900 = "bg-lime-900";

export const backgroundColor_bgLime950 = "bg-lime-950";

export const backgroundColor_bgGreen50 = "bg-green-50";

export const backgroundColor_bgGreen100 = "bg-green-100";

export const backgroundColor_bgGreen200 = "bg-green-200";

export const backgroundColor_bgGreen300 = "bg-green-300";

export const backgroundColor_bgGreen400 = "bg-green-400";

export const backgroundColor_bgGreen500 = "bg-green-500";

export const backgroundColor_bgGreen600 = "bg-green-600";

export const backgroundColor_bgGreen700 = "bg-green-700";

export const backgroundColor_bgGreen800 = "bg-green-800";

export const backgroundColor_bgGreen900 = "bg-green-900";

export const backgroundColor_bgGreen950 = "bg-green-950";

export const backgroundColor_bgEmerald50 = "bg-emerald-50";

export const backgroundColor_bgEmerald100 = "bg-emerald-100";

export const backgroundColor_bgEmerald200 = "bg-emerald-200";

export const backgroundColor_bgEmerald300 = "bg-emerald-300";

export const backgroundColor_bgEmerald400 = "bg-emerald-400";

export const backgroundColor_bgEmerald500 = "bg-emerald-500";

export const backgroundColor_bgEmerald600 = "bg-emerald-600";

export const backgroundColor_bgEmerald700 = "bg-emerald-700";

export const backgroundColor_bgEmerald800 = "bg-emerald-800";

export const backgroundColor_bgEmerald900 = "bg-emerald-900";

export const backgroundColor_bgEmerald950 = "bg-emerald-950";

export const backgroundColor_bgTeal50 = "bg-teal-50";

export const backgroundColor_bgTeal100 = "bg-teal-100";

export const backgroundColor_bgTeal200 = "bg-teal-200";

export const backgroundColor_bgTeal300 = "bg-teal-300";

export const backgroundColor_bgTeal400 = "bg-teal-400";

export const backgroundColor_bgTeal500 = "bg-teal-500";

export const backgroundColor_bgTeal600 = "bg-teal-600";

export const backgroundColor_bgTeal700 = "bg-teal-700";

export const backgroundColor_bgTeal800 = "bg-teal-800";

export const backgroundColor_bgTeal900 = "bg-teal-900";

export const backgroundColor_bgTeal950 = "bg-teal-950";

export const backgroundColor_bgCyan50 = "bg-cyan-50";

export const backgroundColor_bgCyan100 = "bg-cyan-100";

export const backgroundColor_bgCyan200 = "bg-cyan-200";

export const backgroundColor_bgCyan300 = "bg-cyan-300";

export const backgroundColor_bgCyan400 = "bg-cyan-400";

export const backgroundColor_bgCyan500 = "bg-cyan-500";

export const backgroundColor_bgCyan600 = "bg-cyan-600";

export const backgroundColor_bgCyan700 = "bg-cyan-700";

export const backgroundColor_bgCyan800 = "bg-cyan-800";

export const backgroundColor_bgCyan900 = "bg-cyan-900";

export const backgroundColor_bgCyan950 = "bg-cyan-950";

export const backgroundColor_bgSky50 = "bg-sky-50";

export const backgroundColor_bgSky100 = "bg-sky-100";

export const backgroundColor_bgSky200 = "bg-sky-200";

export const backgroundColor_bgSky300 = "bg-sky-300";

export const backgroundColor_bgSky400 = "bg-sky-400";

export const backgroundColor_bgSky500 = "bg-sky-500";

export const backgroundColor_bgSky600 = "bg-sky-600";

export const backgroundColor_bgSky700 = "bg-sky-700";

export const backgroundColor_bgSky800 = "bg-sky-800";

export const backgroundColor_bgSky900 = "bg-sky-900";

export const backgroundColor_bgSky950 = "bg-sky-950";

export const backgroundColor_bgBlue50 = "bg-blue-50";

export const backgroundColor_bgBlue100 = "bg-blue-100";

export const backgroundColor_bgBlue200 = "bg-blue-200";

export const backgroundColor_bgBlue300 = "bg-blue-300";

export const backgroundColor_bgBlue400 = "bg-blue-400";

export const backgroundColor_bgBlue500 = "bg-blue-500";

export const backgroundColor_bgBlue600 = "bg-blue-600";

export const backgroundColor_bgBlue700 = "bg-blue-700";

export const backgroundColor_bgBlue800 = "bg-blue-800";

export const backgroundColor_bgBlue900 = "bg-blue-900";

export const backgroundColor_bgBlue950 = "bg-blue-950";

export const backgroundColor_bgIndigo50 = "bg-indigo-50";

export const backgroundColor_bgIndigo100 = "bg-indigo-100";

export const backgroundColor_bgIndigo200 = "bg-indigo-200";

export const backgroundColor_bgIndigo300 = "bg-indigo-300";

export const backgroundColor_bgIndigo400 = "bg-indigo-400";

export const backgroundColor_bgIndigo500 = "bg-indigo-500";

export const backgroundColor_bgIndigo600 = "bg-indigo-600";

export const backgroundColor_bgIndigo700 = "bg-indigo-700";

export const backgroundColor_bgIndigo800 = "bg-indigo-800";

export const backgroundColor_bgIndigo900 = "bg-indigo-900";

export const backgroundColor_bgIndigo950 = "bg-indigo-950";

export const backgroundColor_bgViolet50 = "bg-violet-50";

export const backgroundColor_bgViolet100 = "bg-violet-100";

export const backgroundColor_bgViolet200 = "bg-violet-200";

export const backgroundColor_bgViolet300 = "bg-violet-300";

export const backgroundColor_bgViolet400 = "bg-violet-400";

export const backgroundColor_bgViolet500 = "bg-violet-500";

export const backgroundColor_bgViolet600 = "bg-violet-600";

export const backgroundColor_bgViolet700 = "bg-violet-700";

export const backgroundColor_bgViolet800 = "bg-violet-800";

export const backgroundColor_bgViolet900 = "bg-violet-900";

export const backgroundColor_bgViolet950 = "bg-violet-950";

export const backgroundColor_bgPurple50 = "bg-purple-50";

export const backgroundColor_bgPurple100 = "bg-purple-100";

export const backgroundColor_bgPurple200 = "bg-purple-200";

export const backgroundColor_bgPurple300 = "bg-purple-300";

export const backgroundColor_bgPurple400 = "bg-purple-400";

export const backgroundColor_bgPurple500 = "bg-purple-500";

export const backgroundColor_bgPurple600 = "bg-purple-600";

export const backgroundColor_bgPurple700 = "bg-purple-700";

export const backgroundColor_bgPurple800 = "bg-purple-800";

export const backgroundColor_bgPurple900 = "bg-purple-900";

export const backgroundColor_bgPurple950 = "bg-purple-950";

export const backgroundColor_bgFuchsia50 = "bg-fuchsia-50";

export const backgroundColor_bgFuchsia100 = "bg-fuchsia-100";

export const backgroundColor_bgFuchsia200 = "bg-fuchsia-200";

export const backgroundColor_bgFuchsia300 = "bg-fuchsia-300";

export const backgroundColor_bgFuchsia400 = "bg-fuchsia-400";

export const backgroundColor_bgFuchsia500 = "bg-fuchsia-500";

export const backgroundColor_bgFuchsia600 = "bg-fuchsia-600";

export const backgroundColor_bgFuchsia700 = "bg-fuchsia-700";

export const backgroundColor_bgFuchsia800 = "bg-fuchsia-800";

export const backgroundColor_bgFuchsia900 = "bg-fuchsia-900";

export const backgroundColor_bgFuchsia950 = "bg-fuchsia-950";

export const backgroundColor_bgPink50 = "bg-pink-50";

export const backgroundColor_bgPink100 = "bg-pink-100";

export const backgroundColor_bgPink200 = "bg-pink-200";

export const backgroundColor_bgPink300 = "bg-pink-300";

export const backgroundColor_bgPink400 = "bg-pink-400";

export const backgroundColor_bgPink500 = "bg-pink-500";

export const backgroundColor_bgPink600 = "bg-pink-600";

export const backgroundColor_bgPink700 = "bg-pink-700";

export const backgroundColor_bgPink800 = "bg-pink-800";

export const backgroundColor_bgPink900 = "bg-pink-900";

export const backgroundColor_bgPink950 = "bg-pink-950";

export const backgroundColor_bgRose50 = "bg-rose-50";

export const backgroundColor_bgRose100 = "bg-rose-100";

export const backgroundColor_bgRose200 = "bg-rose-200";

export const backgroundColor_bgRose300 = "bg-rose-300";

export const backgroundColor_bgRose400 = "bg-rose-400";

export const backgroundColor_bgRose500 = "bg-rose-500";

export const backgroundColor_bgRose600 = "bg-rose-600";

export const backgroundColor_bgRose700 = "bg-rose-700";

export const backgroundColor_bgRose800 = "bg-rose-800";

export const backgroundColor_bgRose900 = "bg-rose-900";

export const backgroundColor_bgRose950 = "bg-rose-950";

export const borderRadius_roundedNone = "rounded-none";

export const borderRadius_roundedSm = "rounded-sm";

export const borderRadius_rounded = "rounded";

export const borderRadius_roundedMd = "rounded-md";

export const borderRadius_roundedLg = "rounded-lg";

export const borderRadius_roundedXl = "rounded-xl";

export const borderRadius_rounded2Xl = "rounded-2xl";

export const borderRadius_rounded3Xl = "rounded-3xl";

export const borderWidth_borderR = "border-r";

export const borderWidth_borderL = "border-l";

export const borderWidth_borderT = "border-t";

export const borderWidth_borderB = "border-b";

export const boxShadow_shadow2Xs = "shadow-2xs";

export const boxShadow_shadowXs = "shadow-xs";

export const boxShadow_shadowSm = "shadow-sm";

export const boxShadow_shadow = "shadow";

export const boxShadow_shadowMd = "shadow-md";

export const boxShadow_shadowLg = "shadow-lg";

export const boxShadow_shadowXl = "shadow-xl";

export const boxShadow_shadow2Xl = "shadow-2xl";

export const boxShadow_shadowInner = "shadow-inner";

export const boxShadow_shadowNone = "shadow-none";

export const display_block = "block";

export const display_inlineBlock = "inline-block";

export const display_inline$0027 = "inline";

export const display_flex = "flex";

export const display_inlineFlex = "inline-flex";

export const display_grid = "grid";

export const display_inlineGrid = "inline-grid";

export const display_hidden = "hidden";

export const display_contents = "contents";

export const display_flowRoot = "flow-root";

export const display_table = "table";

export const display_tableRow = "table-row";

export const display_tableCell = "table-cell";

export const flex_flex = "flex";

export const flex_flex1 = "flex-1";

export const flex_flexAuto = "flex-auto";

export const flex_flexInitial = "flex-initial";

export const flex_flexNone = "flex-none";

export const flex_flexRow = "flex-row";

export const flex_flexWrap = "flex-wrap";

export const flex_flexWrapReverse = "flex-wrap-reverse";

export const flex_flexNoWrap = "flex-nowrap";

export const flex_flexCol = "flex-col";

export const flexDirection_flexRow = "flex-row";

export const flexDirection_flexRowReserve = "flex-row-reserve";

export const flexDirection_flexCol = "flex-col";

export const flexDirection_flexColReserve = "flex-col-reserve";

export const flexShrink_flexShrink = "flex-shrink";

export const flexShrink_flexShrink0 = "flex-shrink-0";

export const flexGrow_flexGrow = "flex-grow";

export const flexGrow_flexGrow0 = "flex-grow-0";

export const fontSize_textXs = "text-xs";

export const fontSize_textSm = "text-sm";

export const fontSize_textBase = "text-base";

export const fontSize_textLg = "text-lg";

export const fontSize_textXl = "text-xl";

export const fontSize_text2Xl = "text-2xl";

export const fontSize_text3Xl = "text-3xl";

export const fontSize_text4Xl = "text-4xl";

export const fontSize_text5Xl = "text-5xl";

export const fontSize_text6Xl = "text-6xl";

export const fontSize_text7Xl = "text-7xl";

export const fontSize_text8Xl = "text-8xl";

export const fontSize_text9Xl = "text-9xl";

export const fontWeight_fontThin = "font-thin";

export const fontWeight_fontExtraLight = "font-extralight";

export const fontWeight_fontLight = "font-light";

export const fontWeight_fontNormal = "font-normal";

export const fontWeight_fontMedium = "font-medium";

export const fontWeight_fontSemibold = "font-semibold";

export const fontWeight_fontBold = "font-bold";

export const fontWeight_fontExtraBold = "font-extrabold";

export const fontWeight_fontBlack = "font-black";

export const minHeight_minHAuto = "min-h-auto";

export const minHeight_minHFull = "min-h-full";

export const minHeight_minHScreen = "min-h-screen";

export const minHeight_minHMin = "min-h-min";

export const minHeight_minHMax = "min-h-max";

export const minHeight_minHFit = "min-h-fit";

export const height_h0 = "h-0";

export const height_hpx = "h-px";

export const height_h0_5 = "h-0.5";

export const height_h1 = "h-1";

export const height_h1_5 = "h-1.5";

export const height_h2 = "h-2";

export const height_h2_5 = "h-2.5";

export const height_h3 = "h-3";

export const height_h3_5 = "h-3.5";

export const height_h4 = "h-4";

export const height_h5 = "h-5";

export const height_h6 = "h-6";

export const height_h7 = "h-7";

export const height_h8 = "h-8";

export const height_h9 = "h-9";

export const height_h10 = "h-10";

export const height_h11 = "h-11";

export const height_h12 = "h-12";

export const height_h14 = "h-14";

export const height_h16 = "h-16";

export const height_h20 = "h-20";

export const height_h24 = "h-24";

export const height_h28 = "h-28";

export const height_h32 = "h-32";

export const height_h36 = "h-36";

export const height_h40 = "h-40";

export const height_h44 = "h-44";

export const height_h48 = "h-48";

export const height_h52 = "h-52";

export const height_h56 = "h-56";

export const height_h60 = "h-60";

export const height_h64 = "h-64";

export const height_h72 = "h-72";

export const height_h80 = "h-80";

export const height_h96 = "h-96";

export const height_hAuto = "h-auto";

export const height_h1$002F2 = "h-1/2";

export const height_h1$002F3 = "h-1/3";

export const height_h2$002F3 = "h-2/3";

export const height_h1$002F4 = "h-1/4";

export const height_h2$002F4 = "h-2/4";

export const height_h3$002F4 = "h-3/4";

export const height_h1$002F5 = "h-1/5";

export const height_h2$002F5 = "h-2/5";

export const height_h3$002F5 = "h-3/5";

export const height_h4$002F5 = "h-4/5";

export const height_h1$002F6 = "h-1/6";

export const height_h2$002F6 = "h-2/6";

export const height_h3$002F6 = "h-3/6";

export const height_h4$002F6 = "h-4/6";

export const height_h5$002F6 = "h-5/6";

export const height_hFull = "h-full";

export const height_hScreen = "h-screen";

export const height_hMin = "h-min";

export const height_hMax = "h-max";

export const height_hFit = "h-fit";

export const justifyContent_justifyStart = "justify-start";

export const justifyContent_justifyEnd = "justify-end";

export const justifyContent_justifyCenter = "justify-center";

export const justifyContent_justifyBetween = "justify-between";

export const justifyContent_justifyAround = "justify-around";

export const justifyContent_justifyEvenly = "justify-evenly";

export const justifyContent_justifyItemsStart = "justify-items-start";

export const justifyContent_justifyItemsEnd = "justify-items-end";

export const justifyContent_justifyItemsCenter = "justify-items-center";

export const justifyContent_justifyItemsStretch = "justify-items-stretch";

export const justifyContent_justifyItemsBaseline = "justify-items-baseline";

export const margin_m0 = "m-0";

export const margin_mx0 = "mx-0";

export const margin_my0 = "my-0";

export const margin_mt0 = "mt-0";

export const margin_mr0 = "mr-0";

export const margin_mb0 = "mb-0";

export const margin_ml0 = "ml-0";

export const margin_mpx = "m-px";

export const margin_mxpx = "mx-px";

export const margin_mtpx = "mt-px";

export const margin_mrpx = "mr-px";

export const margin_mbpx = "mb-px";

export const margin_mlpx = "ml-px";

export const margin_m0_5 = "m-0.5";

export const margin_mx0_5 = "mx-0.5";

export const margin_my0_5 = "my-0.5";

export const margin_mt0_5 = "mt-0.5";

export const margin_mr0_5 = "mr-0.5";

export const margin_mb0_5 = "mb-0.5";

export const margin_ml0_5 = "ml-0.5";

export const margin_m1 = "m-1";

export const margin_mx1 = "mx-1";

export const margin_my1 = "my-1";

export const margin_mt1 = "mt-1";

export const margin_mr1 = "mr-1";

export const margin_mb1 = "mb-1";

export const margin_ml1 = "ml-1";

export const margin_m1_5 = "m-1.5";

export const margin_mx1_5 = "mx-1.5";

export const margin_my1_5 = "my-1.5";

export const margin_mt1_5 = "mt-1.5";

export const margin_mr1_5 = "mr-1.5";

export const margin_mb1_5 = "mb-1.5";

export const margin_ml1_5 = "ml-1.5";

export const margin_m2 = "m-2";

export const margin_mx2 = "mx-2";

export const margin_my2 = "my-2";

export const margin_mt2 = "mt-2";

export const margin_mr2 = "mr-2";

export const margin_mb2 = "mb-2";

export const margin_ml2 = "ml-2";

export const margin_m2_5 = "m-2.5";

export const margin_mx2_5 = "mx-2.5";

export const margin_my2_5 = "my-2.5";

export const margin_mt2_5 = "mt-2.5";

export const margin_mr2_5 = "mr-2.5";

export const margin_mb2_5 = "mb-2.5";

export const margin_ml2_5 = "ml-2.5";

export const margin_m3 = "m-3";

export const margin_mx3 = "mx-3";

export const margin_my3 = "my-3";

export const margin_mt3 = "mt-3";

export const margin_mr3 = "mr-3";

export const margin_mb3 = "mb-3";

export const margin_ml3 = "ml-3";

export const margin_m3_5 = "m-3.5";

export const margin_mx3_5 = "mx-3.5";

export const margin_my3_5 = "my-3.5";

export const margin_mt3_5 = "mt-3.5";

export const margin_mr3_5 = "mr-3.5";

export const margin_mb3_5 = "mb-3.5";

export const margin_ml3_5 = "ml-3.5";

export const margin_m4 = "m-4";

export const margin_mx4 = "mx-4";

export const margin_my4 = "my-4";

export const margin_mt4 = "mt-4";

export const margin_mr4 = "mr-4";

export const margin_mb4 = "mb-4";

export const margin_ml4 = "ml-4";

export const margin_m5 = "m-5";

export const margin_mx5 = "mx-5";

export const margin_my5 = "my-5";

export const margin_mt5 = "mt-5";

export const margin_mr5 = "mr-5";

export const margin_mb5 = "mb-5";

export const margin_ml5 = "ml-5";

export const margin_m6 = "m-6";

export const margin_mx6 = "mx-6";

export const margin_my6 = "my-6";

export const margin_mt6 = "mt-6";

export const margin_mr6 = "mr-6";

export const margin_mb6 = "mb-6";

export const margin_ml6 = "ml-6";

export const margin_m7 = "m-7";

export const margin_mx7 = "mx-7";

export const margin_my7 = "my-7";

export const margin_mt7 = "mt-7";

export const margin_mr7 = "mr-7";

export const margin_mb7 = "mb-7";

export const margin_ml7 = "ml-7";

export const margin_m8 = "m-8";

export const margin_mx8 = "mx-8";

export const margin_my8 = "my-8";

export const margin_mt8 = "mt-8";

export const margin_mr8 = "mr-8";

export const margin_mb8 = "mb-8";

export const margin_ml8 = "ml-8";

export const margin_m9 = "m-9";

export const margin_mx9 = "mx-9";

export const margin_my9 = "my-9";

export const margin_mt9 = "mt-9";

export const margin_mr9 = "mr-9";

export const margin_mb9 = "mb-9";

export const margin_ml9 = "ml-9";

export const margin_m10 = "m-10";

export const margin_mx10 = "mx-10";

export const margin_my10 = "my-10";

export const margin_mt10 = "mt-10";

export const margin_mr10 = "mr-10";

export const margin_mb10 = "mb-10";

export const margin_ml10 = "ml-10";

export const margin_m11 = "m-11";

export const margin_mx11 = "mx-11";

export const margin_my11 = "my-11";

export const margin_mt11 = "mt-11";

export const margin_mr11 = "mr-11";

export const margin_mb11 = "mb-11";

export const margin_ml11 = "ml-11";

export const margin_m12 = "m-12";

export const margin_mx12 = "mx-12";

export const margin_my12 = "my-12";

export const margin_mt12 = "mt-12";

export const margin_mr12 = "mr-12";

export const margin_mb12 = "mb-12";

export const margin_ml12 = "ml-12";

export const margin_m14 = "m-14";

export const margin_mx14 = "mx-14";

export const margin_my14 = "my-14";

export const margin_mt14 = "mt-14";

export const margin_mr14 = "mr-14";

export const margin_mb14 = "mb-14";

export const margin_ml14 = "ml-14";

export const margin_m16 = "m-16";

export const margin_mx16 = "mx-16";

export const margin_my16 = "my-16";

export const margin_mt16 = "mt-16";

export const margin_mr16 = "mr-16";

export const margin_mb16 = "mb-16";

export const margin_ml16 = "ml-16";

export const margin_m20 = "m-20";

export const margin_mx20 = "mx-20";

export const margin_my20 = "my-20";

export const margin_mt20 = "mt-20";

export const margin_mr20 = "mr-20";

export const margin_mb20 = "mb-20";

export const margin_ml20 = "ml-20";

export const margin_m24 = "m-24";

export const margin_mx24 = "mx-24";

export const margin_my24 = "my-24";

export const margin_mt24 = "mt-24";

export const margin_mr24 = "mr-24";

export const margin_mb24 = "mb-24";

export const margin_ml24 = "ml-24";

export const margin_m28 = "m-28";

export const margin_mx28 = "mx-28";

export const margin_my28 = "my-28";

export const margin_mt28 = "mt-28";

export const margin_mr28 = "mr-28";

export const margin_mb28 = "mb-28";

export const margin_ml28 = "ml-28";

export const margin_m32 = "m-32";

export const margin_mx32 = "mx-32";

export const margin_my32 = "my-32";

export const margin_mt32 = "mt-32";

export const margin_mr32 = "mr-32";

export const margin_mb32 = "mb-32";

export const margin_ml32 = "ml-32";

export const margin_m36 = "m-36";

export const margin_mx36 = "mx-36";

export const margin_my36 = "my-36";

export const margin_mt36 = "mt-36";

export const margin_mr36 = "mr-36";

export const margin_mb36 = "mb-36";

export const margin_ml36 = "ml-36";

export const margin_m40 = "m-40";

export const margin_mx40 = "mx-40";

export const margin_my40 = "my-40";

export const margin_mt40 = "mt-40";

export const margin_mr40 = "mr-40";

export const margin_mb40 = "mb-40";

export const margin_ml40 = "ml-40";

export const margin_m44 = "m-44";

export const margin_mx44 = "mx-44";

export const margin_my44 = "my-44";

export const margin_mt44 = "mt-44";

export const margin_mr44 = "mr-44";

export const margin_mb44 = "mb-44";

export const margin_ml44 = "ml-44";

export const margin_m48 = "m-48";

export const margin_mx48 = "mx-48";

export const margin_my48 = "my-48";

export const margin_mt48 = "mt-48";

export const margin_mr48 = "mr-48";

export const margin_mb48 = "mb-48";

export const margin_ml48 = "ml-48";

export const margin_m52 = "m-52";

export const margin_mx52 = "mx-52";

export const margin_my52 = "my-52";

export const margin_mt52 = "mt-52";

export const margin_mr52 = "mr-52";

export const margin_mb52 = "mb-52";

export const margin_ml52 = "ml-52";

export const margin_m56 = "m-56";

export const margin_mx56 = "mx-56";

export const margin_my56 = "my-56";

export const margin_mt56 = "mt-56";

export const margin_mr56 = "mr-56";

export const margin_mb56 = "mb-56";

export const margin_ml56 = "ml-56";

export const margin_m60 = "m-60";

export const margin_mx60 = "mx-60";

export const margin_my60 = "my-60";

export const margin_mt60 = "mt-60";

export const margin_mr60 = "mr-60";

export const margin_mb60 = "mb-60";

export const margin_ml60 = "ml-60";

export const margin_m64 = "m-64";

export const margin_mx64 = "mx-64";

export const margin_my64 = "my-64";

export const margin_mt64 = "mt-64";

export const margin_mr64 = "mr-64";

export const margin_mb64 = "mb-64";

export const margin_ml64 = "ml-64";

export const margin_m72 = "m-72";

export const margin_mx72 = "mx-72";

export const margin_my72 = "my-72";

export const margin_mt72 = "mt-72";

export const margin_mr72 = "mr-72";

export const margin_mb72 = "mb-72";

export const margin_ml72 = "ml-72";

export const margin_m80 = "m-80";

export const margin_mx80 = "mx-80";

export const margin_my80 = "my-80";

export const margin_mt80 = "mt-80";

export const margin_mr80 = "mr-80";

export const margin_mb80 = "mb-80";

export const margin_ml80 = "ml-80";

export const margin_m96 = "m-96";

export const margin_mx96 = "mx-96";

export const margin_my96 = "my-96";

export const margin_mt96 = "mt-96";

export const margin_mr96 = "mr-96";

export const margin_mb96 = "mb-96";

export const margin_mAuto = "m-auto";

export const margin_mxAuto = "mx-auto";

export const margin_myAuto = "my-auto";

export const margin_mtAuto = "mt-auto";

export const margin_mrAuto = "mr-auto";

export const margin_mbAuto = "mb-auto";

export const margin_mlAuto = "ml-auto";

export const maxWidth_w0 = "max-w-0";

export const maxWidth_wNone = "max-w-none";

export const maxWidth_wXs = "max-w-xs";

export const maxWidth_wSm = "max-w-sm";

export const maxWidth_wMm = "max-w-md";

export const maxWidth_wLg = "max-w-lg";

export const maxWidth_wXl = "max-w-xl";

export const maxWidth_w2Xl = "max-w-2xl";

export const maxWidth_w3Xl = "max-w-3xl";

export const maxWidth_w4Xl = "max-w-4xl";

export const maxWidth_w5Xl = "max-w-5xl";

export const maxWidth_w6Xl = "max-w-6xl";

export const maxWidth_w7Xl = "max-w-7xl";

export const maxWidth_wFull = "max-w-full";

export const maxWidth_wMin = "max-w-min";

export const maxWidth_wMax = "max-w-max";

export const maxWidth_wFit = "max-w-fit";

export const maxWidth_wProse = "max-w-prose";

export const maxWidth_wScreenSm = "max-w-screen-sm";

export const maxWidth_wScreenMd = "max-w-screen-md";

export const maxWidth_wScreenLg = "max-w-screen-lg";

export const maxWidth_wScreenXl = "max-w-screen-xl";

export const maxWidth_wScreen2Xl = "max-w-screen-2xl";

export const maxHeight_h0 = "max-h-0";

export const maxHeight_hPx = "max-h-px";

export const maxHeight_h0_5 = "max-h-0.5";

export const maxHeight_h1 = "max-h-1";

export const maxHeight_h1_5 = "max-h-1.5";

export const maxHeight_h2 = "max-h-2";

export const maxHeight_h2_5 = "max-h-2.5";

export const maxHeight_h3 = "max-h-3";

export const maxHeight_h3_5 = "max-h-3.5";

export const maxHeight_h4 = "max-h-4";

export const maxHeight_h5 = "max-h-5";

export const maxHeight_h6 = "max-h-6";

export const maxHeight_h7 = "max-h-7";

export const maxHeight_h8 = "max-h-8";

export const maxHeight_h9 = "max-h-9";

export const maxHeight_h10 = "max-h-10";

export const maxHeight_h11 = "max-h-11";

export const maxHeight_h12 = "max-h-12";

export const maxHeight_h14 = "max-h-14";

export const maxHeight_h16 = "max-h-16";

export const maxHeight_h20 = "max-h-20";

export const maxHeight_h24 = "max-h-24";

export const maxHeight_h28 = "max-h-28";

export const maxHeight_h32 = "max-h-32";

export const maxHeight_h36 = "max-h-36";

export const maxHeight_h40 = "max-h-40";

export const maxHeight_h44 = "max-h-44";

export const maxHeight_h48 = "max-h-48";

export const maxHeight_h52 = "max-h-52";

export const maxHeight_h56 = "max-h-56";

export const maxHeight_h60 = "max-h-60";

export const maxHeight_h64 = "max-h-64";

export const maxHeight_h72 = "max-h-72";

export const maxHeight_h80 = "max-h-80";

export const maxHeight_h96 = "max-h-96";

export const maxHeight_hFull = "max-h-full";

export const maxHeight_hScreen = "max-h-screen";

export const maxHeight_hMin = "max-h-min";

export const maxHeight_hMax = "max-h-max";

export const maxHeight_hFit = "max-h-fit";

export const outline_outlineNone = "outline-none";

export const outline_outline = "outline";

export const outline_outlineDashed = "outline-dashed";

export const outline_outlineDotted = "outline-dotted";

export const outline_outlineDouble = "outline-double";

export const overflow_overflowAuto = "overflow-auto";

export const overflow_overflowHidden = "overflow-hidden";

export const overflow_overflowClip = "overflow-clip";

export const overflow_overflowVisible = "overflow-visible";

export const overflow_overflowScroll = "overflow-scroll";

export const overflow_overflowXAuto = "overflow-x-auto";

export const overflow_overflowYAuto = "overflow-y-auto";

export const overflow_overflowXHidden = "overflow-x-hidden";

export const textColor_inherit = "text-inherit";

export const textColor_current = "text-current";

export const textColor_transparent = "text-transparent";

export const textColor_black = "text-black";

export const textColor_white = "text-white";

export const textColor_slate50 = "text-slate-50";

export const textColor_slate100 = "text-slate-100";

export const textColor_slate200 = "text-slate-200";

export const textColor_slate300 = "text-slate-300";

export const textColor_slate400 = "text-slate-400";

export const textColor_slate500 = "text-slate-500";

export const textColor_slate600 = "text-slate-600";

export const textColor_slate700 = "text-slate-700";

export const textColor_slate800 = "text-slate-800";

export const textColor_slate900 = "text-slate-900";

export const textColor_slate950 = "text-slate-950";

export const textColor_gray50 = "text-gray-50";

export const textColor_gray100 = "text-gray-100";

export const textColor_gray200 = "text-gray-200";

export const textColor_gray300 = "text-gray-300";

export const textColor_gray400 = "text-gray-400";

export const textColor_gray500 = "text-gray-500";

export const textColor_gray600 = "text-gray-600";

export const textColor_gray700 = "text-gray-700";

export const textColor_gray800 = "text-gray-800";

export const textColor_gray900 = "text-gray-900";

export const textColor_gray950 = "text-gray-950";

export const textColor_zinc50 = "text-zinc-50";

export const textColor_zinc100 = "text-zinc-100";

export const textColor_zinc200 = "text-zinc-200";

export const textColor_zinc300 = "text-zinc-300";

export const textColor_zinc400 = "text-zinc-400";

export const textColor_zinc500 = "text-zinc-500";

export const textColor_zinc600 = "text-zinc-600";

export const textColor_zinc700 = "text-zinc-700";

export const textColor_zinc800 = "text-zinc-800";

export const textColor_zinc900 = "text-zinc-900";

export const textColor_zinc950 = "text-zinc-950";

export const textColor_neutral50 = "text-neutral-50";

export const textColor_neutral100 = "text-neutral-100";

export const textColor_neutral200 = "text-neutral-200";

export const textColor_neutral300 = "text-neutral-300";

export const textColor_neutral400 = "text-neutral-400";

export const textColor_neutral500 = "text-neutral-500";

export const textColor_neutral600 = "text-neutral-600";

export const textColor_neutral700 = "text-neutral-700";

export const textColor_neutral800 = "text-neutral-800";

export const textColor_neutral900 = "text-neutral-900";

export const textColor_neutral950 = "text-neutral-950";

export const textColor_stone50 = "text-stone-50";

export const textColor_stone100 = "text-stone-100";

export const textColor_stone200 = "text-stone-200";

export const textColor_stone300 = "text-stone-300";

export const textColor_stone400 = "text-stone-400";

export const textColor_stone500 = "text-stone-500";

export const textColor_stone600 = "text-stone-600";

export const textColor_stone700 = "text-stone-700";

export const textColor_stone800 = "text-stone-800";

export const textColor_stone900 = "text-stone-900";

export const textColor_stone950 = "text-stone-950";

export const textColor_red50 = "text-red-50";

export const textColor_red100 = "text-red-100";

export const textColor_red200 = "text-red-200";

export const textColor_red300 = "text-red-300";

export const textColor_red400 = "text-red-400";

export const textColor_red500 = "text-red-500";

export const textColor_red600 = "text-red-600";

export const textColor_red700 = "text-red-700";

export const textColor_red800 = "text-red-800";

export const textColor_red900 = "text-red-900";

export const textColor_red950 = "text-red-950";

export const textColor_orange50 = "text-orange-50";

export const textColor_orange100 = "text-orange-100";

export const textColor_orange200 = "text-orange-200";

export const textColor_orange300 = "text-orange-300";

export const textColor_orange400 = "text-orange-400";

export const textColor_orange500 = "text-orange-500";

export const textColor_orange600 = "text-orange-600";

export const textColor_orange700 = "text-orange-700";

export const textColor_orange800 = "text-orange-800";

export const textColor_orange900 = "text-orange-900";

export const textColor_orange950 = "text-orange-950";

export const textColor_amber50 = "text-amber-50";

export const textColor_amber100 = "text-amber-100";

export const textColor_amber200 = "text-amber-200";

export const textColor_amber300 = "text-amber-300";

export const textColor_amber400 = "text-amber-400";

export const textColor_amber500 = "text-amber-500";

export const textColor_amber600 = "text-amber-600";

export const textColor_amber700 = "text-amber-700";

export const textColor_amber800 = "text-amber-800";

export const textColor_amber900 = "text-amber-900";

export const textColor_amber950 = "text-amber-950";

export const textColor_yellow50 = "text-yellow-50";

export const textColor_yellow100 = "text-yellow-100";

export const textColor_yellow200 = "text-yellow-200";

export const textColor_yellow300 = "text-yellow-300";

export const textColor_yellow400 = "text-yellow-400";

export const textColor_yellow500 = "text-yellow-500";

export const textColor_yellow600 = "text-yellow-600";

export const textColor_yellow700 = "text-yellow-700";

export const textColor_yellow800 = "text-yellow-800";

export const textColor_yellow900 = "text-yellow-900";

export const textColor_yellow950 = "text-yellow-950";

export const textColor_lime50 = "text-lime-50";

export const textColor_lime100 = "text-lime-100";

export const textColor_lime200 = "text-lime-200";

export const textColor_lime300 = "text-lime-300";

export const textColor_lime400 = "text-lime-400";

export const textColor_lime500 = "text-lime-500";

export const textColor_lime600 = "text-lime-600";

export const textColor_lime700 = "text-lime-700";

export const textColor_lime800 = "text-lime-800";

export const textColor_lime900 = "text-lime-900";

export const textColor_lime950 = "text-lime-950";

export const textColor_green50 = "text-green-50";

export const textColor_green100 = "text-green-100";

export const textColor_green200 = "text-green-200";

export const textColor_green300 = "text-green-300";

export const textColor_green400 = "text-green-400";

export const textColor_green500 = "text-green-500";

export const textColor_green600 = "text-green-600";

export const textColor_green700 = "text-green-700";

export const textColor_green800 = "text-green-800";

export const textColor_green900 = "text-green-900";

export const textColor_green950 = "text-green-950";

export const textColor_emerald50 = "text-emerald-50";

export const textColor_emerald100 = "text-emerald-100";

export const textColor_emerald200 = "text-emerald-200";

export const textColor_emerald300 = "text-emerald-300";

export const textColor_emerald400 = "text-emerald-400";

export const textColor_emerald500 = "text-emerald-500";

export const textColor_emerald600 = "text-emerald-600";

export const textColor_emerald700 = "text-emerald-700";

export const textColor_emerald800 = "text-emerald-800";

export const textColor_emerald900 = "text-emerald-900";

export const textColor_emerald950 = "text-emerald-950";

export const textColor_teal50 = "text-teal-50";

export const textColor_teal100 = "text-teal-100";

export const textColor_teal200 = "text-teal-200";

export const textColor_teal300 = "text-teal-300";

export const textColor_teal400 = "text-teal-400";

export const textColor_teal500 = "text-teal-500";

export const textColor_teal600 = "text-teal-600";

export const textColor_teal700 = "text-teal-700";

export const textColor_teal800 = "text-teal-800";

export const textColor_teal900 = "text-teal-900";

export const textColor_teal950 = "text-teal-950";

export const textColor_cyan50 = "text-cyan-50";

export const textColor_cyan100 = "text-cyan-100";

export const textColor_cyan200 = "text-cyan-200";

export const textColor_cyan300 = "text-cyan-300";

export const textColor_cyan400 = "text-cyan-400";

export const textColor_cyan500 = "text-cyan-500";

export const textColor_cyan600 = "text-cyan-600";

export const textColor_cyan700 = "text-cyan-700";

export const textColor_cyan800 = "text-cyan-800";

export const textColor_cyan900 = "text-cyan-900";

export const textColor_cyan950 = "text-cyan-950";

export const textColor_sky50 = "text-sky-50";

export const textColor_sky100 = "text-sky-100";

export const textColor_sky200 = "text-sky-200";

export const textColor_sky300 = "text-sky-300";

export const textColor_sky400 = "text-sky-400";

export const textColor_sky500 = "text-sky-500";

export const textColor_sky600 = "text-sky-600";

export const textColor_sky700 = "text-sky-700";

export const textColor_sky800 = "text-sky-800";

export const textColor_sky900 = "text-sky-900";

export const textColor_sky950 = "text-sky-950";

export const textColor_blue50 = "text-blue-50";

export const textColor_blue100 = "text-blue-100";

export const textColor_blue200 = "text-blue-200";

export const textColor_blue300 = "text-blue-300";

export const textColor_blue400 = "text-blue-400";

export const textColor_blue500 = "text-blue-500";

export const textColor_blue600 = "text-blue-600";

export const textColor_blue700 = "text-blue-700";

export const textColor_blue800 = "text-blue-800";

export const textColor_blue900 = "text-blue-900";

export const textColor_blue950 = "text-blue-950";

export const textColor_indigo50 = "text-indigo-50";

export const textColor_indigo100 = "text-indigo-100";

export const textColor_indigo200 = "text-indigo-200";

export const textColor_indigo300 = "text-indigo-300";

export const textColor_indigo400 = "text-indigo-400";

export const textColor_indigo500 = "text-indigo-500";

export const textColor_indigo600 = "text-indigo-600";

export const textColor_indigo700 = "text-indigo-700";

export const textColor_indigo800 = "text-indigo-800";

export const textColor_indigo900 = "text-indigo-900";

export const textColor_indigo950 = "text-indigo-950";

export const textColor_violet50 = "text-violet-50";

export const textColor_violet100 = "text-violet-100";

export const textColor_violet200 = "text-violet-200";

export const textColor_violet300 = "text-violet-300";

export const textColor_violet400 = "text-violet-400";

export const textColor_violet500 = "text-violet-500";

export const textColor_violet600 = "text-violet-600";

export const textColor_violet700 = "text-violet-700";

export const textColor_violet800 = "text-violet-800";

export const textColor_violet900 = "text-violet-900";

export const textColor_violet950 = "text-violet-950";

export const textColor_purple50 = "text-purple-50";

export const textColor_purple100 = "text-purple-100";

export const textColor_purple200 = "text-purple-200";

export const textColor_purple300 = "text-purple-300";

export const textColor_purple400 = "text-purple-400";

export const textColor_purple500 = "text-purple-500";

export const textColor_purple600 = "text-purple-600";

export const textColor_purple700 = "text-purple-700";

export const textColor_purple800 = "text-purple-800";

export const textColor_purple900 = "text-purple-900";

export const textColor_purple950 = "text-purple-950";

export const textColor_fuchsia50 = "text-fuchsia-50";

export const textColor_fuchsia100 = "text-fuchsia-100";

export const textColor_fuchsia200 = "text-fuchsia-200";

export const textColor_fuchsia300 = "text-fuchsia-300";

export const textColor_fuchsia400 = "text-fuchsia-400";

export const textColor_fuchsia500 = "text-fuchsia-500";

export const textColor_fuchsia600 = "text-fuchsia-600";

export const textColor_fuchsia700 = "text-fuchsia-700";

export const textColor_fuchsia800 = "text-fuchsia-800";

export const textColor_fuchsia900 = "text-fuchsia-900";

export const textColor_fuchsia950 = "text-fuchsia-950";

export const textColor_pink50 = "text-pink-50";

export const textColor_pink100 = "text-pink-100";

export const textColor_pink200 = "text-pink-200";

export const textColor_pink300 = "text-pink-300";

export const textColor_pink400 = "text-pink-400";

export const textColor_pink500 = "text-pink-500";

export const textColor_pink600 = "text-pink-600";

export const textColor_pink700 = "text-pink-700";

export const textColor_pink800 = "text-pink-800";

export const textColor_pink900 = "text-pink-900";

export const textColor_pink950 = "text-pink-950";

export const textColor_rose50 = "text-rose-50";

export const textColor_rose100 = "text-rose-100";

export const textColor_rose200 = "text-rose-200";

export const textColor_rose300 = "text-rose-300";

export const textColor_rose400 = "text-rose-400";

export const textColor_rose500 = "text-rose-500";

export const textColor_rose600 = "text-rose-600";

export const textColor_rose700 = "text-rose-700";

export const textColor_rose800 = "text-rose-800";

export const textColor_rose900 = "text-rose-900";

export const textColor_rose950 = "text-rose-950";

export const padding_p0 = "p-0";

export const padding_p1 = "p-1";

export const padding_p2 = "p-2";

export const padding_p3 = "p-3";

export const padding_p4 = "p-4";

export const padding_p5 = "p-5";

export const padding_p6 = "p-6";

export const padding_p7 = "p-7";

export const padding_p8 = "p-8";

export const padding_p9 = "p-9";

export const padding_p10 = "p-10";

export const padding_p11 = "p-11";

export const padding_p12 = "p-12";

export const padding_p14 = "p-14";

export const padding_p16 = "p-16";

export const padding_p20 = "p-20";

export const padding_p24 = "p-24";

export const padding_pt0 = "pt-0";

export const padding_pt1 = "pt-1";

export const padding_pt2 = "pt-2";

export const padding_pt3 = "pt-3";

export const padding_pt4 = "pt-4";

export const padding_pt5 = "pt-5";

export const padding_pt6 = "pt-6";

export const padding_pt8 = "pt-8";

export const padding_pb0 = "pb-0";

export const padding_pb1 = "pb-1";

export const padding_pb2 = "pb-2";

export const padding_pb3 = "pb-3";

export const padding_pb4 = "pb-4";

export const padding_pb5 = "pb-5";

export const padding_pb6 = "pb-6";

export const padding_pb8 = "pb-8";

export const padding_pr0 = "pr-0";

export const padding_pr1 = "pr-1";

export const padding_pr2 = "pr-2";

export const padding_pr3 = "pr-3";

export const padding_pr4 = "pr-4";

export const padding_pr5 = "pr-5";

export const padding_pr6 = "pr-6";

export const padding_pr8 = "pr-8";

export const padding_pl0 = "pl-0";

export const padding_pl1 = "pl-1";

export const padding_pl2 = "pl-2";

export const padding_pl3 = "pl-3";

export const padding_pl4 = "pl-4";

export const padding_pl5 = "pl-5";

export const padding_pl6 = "pl-6";

export const padding_pl8 = "pl-8";

export const padding_px0 = "px-0";

export const padding_px1 = "px-1";

export const padding_px2 = "px-2";

export const padding_px3 = "px-3";

export const padding_px4 = "px-4";

export const padding_px5 = "px-5";

export const padding_px6 = "px-6";

export const padding_px8 = "px-8";

export const padding_py0 = "py-0";

export const padding_py1 = "py-1";

export const padding_py2 = "py-2";

export const padding_py3 = "py-3";

export const padding_py4 = "py-4";

export const padding_py5 = "py-5";

export const padding_py6 = "py-6";

export const padding_py8 = "py-8";

export const position_absolute = "absolute";

export const position_relative = "relative";

export const position_sticky = "sticky";

export const position_fixed$0027 = "fixed";

export const position_static$0027 = "static";

export const position_inset0 = "inset-0";

export const position_insetAuto = "inset-auto";

export const position_insetX0 = "inset-x-0";

export const position_insetXAuto = "inset-x-auto";

export const position_insetY0 = "inset-y-0";

export const position_insetYAuto = "inset-y-auto";

export const position_top0 = "top-0";

export const position_top1 = "top-1";

export const position_top2 = "top-2";

export const position_top3 = "top-3";

export const position_top4 = "top-4";

export const position_topAuto = "top-auto";

export const position_topFull = "top-full";

export const position_right0 = "right-0";

export const position_right1 = "right-1";

export const position_right2 = "right-2";

export const position_right3 = "right-3";

export const position_right4 = "right-4";

export const position_rightAuto = "right-auto";

export const position_rightFull = "right-full";

export const position_bottom0 = "bottom-0";

export const position_bottom1 = "bottom-1";

export const position_bottom2 = "bottom-2";

export const position_bottom3 = "bottom-3";

export const position_bottom4 = "bottom-4";

export const position_bottomAuto = "bottom-auto";

export const position_bottomFull = "bottom-full";

export const position_left0 = "left-0";

export const position_left1 = "left-1";

export const position_left2 = "left-2";

export const position_left3 = "left-3";

export const position_left4 = "left-4";

export const position_leftAuto = "left-auto";

export const position_leftFull = "left-full";

export const visibility_visible = "visible";

export const visibility_invisible = "invisible";

export const width_w0 = "w-0";

export const width_w1 = "w-1";

export const width_w2 = "w-2";

export const width_w3 = "w-3";

export const width_w4 = "w-4";

export const width_w5 = "w-5";

export const width_w6 = "w-6";

export const width_w7 = "w-7";

export const width_w8 = "w-8";

export const width_w9 = "w-9";

export const width_w10 = "w-10";

export const width_w11 = "w-11";

export const width_w12 = "w-12";

export const width_w14 = "w-14";

export const width_w16 = "w-16";

export const width_w20 = "w-20";

export const width_w24 = "w-24";

export const width_w28 = "w-28";

export const width_w32 = "w-32";

export const width_w36 = "w-36";

export const width_w40 = "w-40";

export const width_w44 = "w-44";

export const width_w48 = "w-48";

export const width_w52 = "w-52";

export const width_w56 = "w-56";

export const width_w60 = "w-60";

export const width_w64 = "w-64";

export const width_w72 = "w-72";

export const width_w80 = "w-80";

export const width_w92 = "w-92";

export const width_w96 = "w-96";

export const width_wAuto = "w-auto";

export const width_w1$002F2 = "w-1/2";

export const width_w1$002F3 = "w-1/3";

export const width_w2$002F3 = "w-2/3";

export const width_w1$002F4 = "w-1/4";

export const width_w2$002F4 = "w-2/4";

export const width_w3$002F4 = "w-3/4";

export const width_w1$002F5 = "w-1/5";

export const width_w2$002F5 = "w-2/5";

export const width_w3$002F5 = "w-3/5";

export const width_w4$002F5 = "w-4/5";

export const width_w1$002F6 = "w-1/6";

export const width_w2$002F6 = "w-2/6";

export const width_w3$002F6 = "w-3/6";

export const width_w4$002F6 = "w-4/6";

export const width_w5$002F6 = "w-5/6";

export const width_w1$002F12 = "w-1/12";

export const width_w2$002F12 = "w-2/12";

export const width_w3$002F12 = "w-3/12";

export const width_w4$002F12 = "w-4/12";

export const width_w5$002F12 = "w-5/12";

export const width_w6$002F12 = "w-6/12";

export const width_w7$002F12 = "w-7/12";

export const width_w8$002F12 = "w-8/12";

export const width_w9$002F12 = "w-9/12";

export const width_w10$002F12 = "w-10/12";

export const width_w11$002F12 = "w-11/12";

export const width_wFull = "w-full";

export const width_wScreen = "w-screen";

export const width_wMin = "w-min";

export const width_wMax = "w-max";

export const width_wFit = "w-fit";

export const grid_cols$002Dnone = "grid-cols-none";

export const grid_cols$002D1 = "grid-cols-1";

export const grid_cols$002D2 = "grid-cols-2";

export const grid_cols$002D3 = "grid-cols-3";

export const grid_cols$002D4 = "grid-cols-4";

export const grid_cols$002D5 = "grid-cols-5";

export const grid_cols$002D6 = "grid-cols-6";

export const grid_cols$002D7 = "grid-cols-7";

export const grid_cols$002D8 = "grid-cols-8";

export const grid_cols$002D9 = "grid-cols-9";

export const grid_cols$002D10 = "grid-cols-10";

export const grid_cols$002D11 = "grid-cols-11";

export const grid_cols$002D12 = "grid-cols-12";

export const grid_grid = "grid";

export const grid_col$002Dspan$002D1 = "col-span-1";

export const grid_col$002Dspan$002D2 = "col-span-2";

export const grid_col$002Dspan$002D3 = "col-span-3";

export const grid_col$002Dspan$002D4 = "col-span-4";

export const grid_col$002Dspan$002D5 = "col-span-5";

export const grid_col$002Dspan$002D6 = "col-span-6";

export const grid_col$002Dspan$002D7 = "col-span-7";

export const grid_col$002Dspan$002D8 = "col-span-8";

export const grid_col$002Dspan$002D9 = "col-span-9";

export const grid_col$002Dspan$002D10 = "col-span-10";

export const grid_col$002Dspan$002D11 = "col-span-11";

export const grid_col$002Dspan$002D12 = "col-span-12";

export const grid_col$002Dspan$002Dfull = "col-span-full";

export const grid_row$002Dspan$002D1 = "row-span-1";

export const grid_row$002Dspan$002D2 = "row-span-2";

export const grid_row$002Dspan$002D3 = "row-span-3";

export const grid_row$002Dspan$002D4 = "row-span-4";

export const grid_row$002Dspan$002D5 = "row-span-5";

export const grid_row$002Dspan$002D6 = "row-span-6";

export const grid_row$002Dspan$002Dfull = "row-span-full";

export const gap_gap$002D0 = "gap-0";

export const gap_gap$002D1 = "gap-1";

export const gap_gap$002D2 = "gap-2";

export const gap_gap$002D3 = "gap-3";

export const gap_gap$002D4 = "gap-4";

export const gap_gap$002D5 = "gap-5";

export const gap_gap$002D6 = "gap-6";

export const gap_gap$002D7 = "gap-7";

export const gap_gap$002Dx$002D0 = "gap-x-0";

export const gap_gap$002Dy$002D0 = "gap-y-0";

export const textAlign_left = "text-left";

export const textAlign_center = "text-center";

export const textAlign_right = "text-right";

export const textAlign_justify = "text-justify";

export const textAlign_start = "text-start";

export const textAlign_end = "text-end";

export const alignItems_itemsStart = "items-start";

export const alignItems_itemsEnd = "items-end";

export const alignItems_itemsEndSafe = "items-end-safe";

export const alignItems_itemsCenter = "items-center";

export const alignItems_itemsCenterSafe = "items-center-safe";

export const alignItems_itemsBaseline = "items-baseline";

export const alignItems_itemsBaselineLast = "items-baseline-last";

export const alignItems_itemsStretch = "items-stretch";

export const zIndex_z0 = "z-0";

export const zIndex_z10 = "z-10";

export const zIndex_z20 = "z-20";

export const zIndex_z30 = "z-30";

export const zIndex_z40 = "z-40";

export const zIndex_z50 = "z-50";

export const zIndex_zAuto = "z-auto";

export const opacity_opacity0 = "opacity-0";

export const opacity_opacity5 = "opacity-5";

export const opacity_opacity10 = "opacity-10";

export const opacity_opacity15 = "opacity-15";

export const opacity_opacity20 = "opacity-20";

export const opacity_opacity25 = "opacity-25";

export const opacity_opacity30 = "opacity-30";

export const opacity_opacity35 = "opacity-35";

export const opacity_opacity40 = "opacity-40";

export const opacity_opacity45 = "opacity-45";

export const opacity_opacity50 = "opacity-50";

export const opacity_opacity55 = "opacity-55";

export const opacity_opacity60 = "opacity-60";

export const opacity_opacity65 = "opacity-65";

export const opacity_opacity70 = "opacity-70";

export const opacity_opacity75 = "opacity-75";

export const opacity_opacity80 = "opacity-80";

export const opacity_opacity85 = "opacity-85";

export const opacity_opacity90 = "opacity-90";

export const opacity_opacity95 = "opacity-95";

export const opacity_opacity100 = "opacity-100";

export const bgOpacity_bgOpacity0 = "bg-opacity-0";

export const bgOpacity_bgOpacity5 = "bg-opacity-5";

export const bgOpacity_bgOpacity10 = "bg-opacity-10";

export const bgOpacity_bgOpacity20 = "bg-opacity-20";

export const bgOpacity_bgOpacity25 = "bg-opacity-25";

export const bgOpacity_bgOpacity30 = "bg-opacity-30";

export const bgOpacity_bgOpacity40 = "bg-opacity-40";

export const bgOpacity_bgOpacity50 = "bg-opacity-50";

export const bgOpacity_bgOpacity60 = "bg-opacity-60";

export const bgOpacity_bgOpacity70 = "bg-opacity-70";

export const bgOpacity_bgOpacity75 = "bg-opacity-75";

export const bgOpacity_bgOpacity80 = "bg-opacity-80";

export const bgOpacity_bgOpacity90 = "bg-opacity-90";

export const bgOpacity_bgOpacity95 = "bg-opacity-95";

export const bgOpacity_bgOpacity100 = "bg-opacity-100";

export const lineHeight_leadingNone = "leading-none";

export const lineHeight_leadingTight = "leading-tight";

export const lineHeight_leadingSnug = "leading-snug";

export const lineHeight_leadingNormal = "leading-normal";

export const lineHeight_leadingRelaxed = "leading-relaxed";

export const lineHeight_leadingLoose = "leading-loose";

export const lineHeight_leading3 = "leading-3";

export const lineHeight_leading4 = "leading-4";

export const lineHeight_leading5 = "leading-5";

export const lineHeight_leading6 = "leading-6";

export const lineHeight_leading7 = "leading-7";

export const lineHeight_leading8 = "leading-8";

export const lineHeight_leading9 = "leading-9";

export const lineHeight_leading10 = "leading-10";

export const letterSpacing_trackingTighter = "tracking-tighter";

export const letterSpacing_trackingTight = "tracking-tight";

export const letterSpacing_trackingNormal = "tracking-normal";

export const letterSpacing_trackingWide = "tracking-wide";

export const letterSpacing_trackingWider = "tracking-wider";

export const letterSpacing_trackingWidest = "tracking-widest";

export const textDecoration_underline = "underline";

export const textDecoration_overline = "overline";

export const textDecoration_lineThrough = "line-through";

export const textDecoration_noUnderline = "no-underline";

export const textDecorationStyle_decorationSolid = "decoration-solid";

export const textDecorationStyle_decorationDouble = "decoration-double";

export const textDecorationStyle_decorationDotted = "decoration-dotted";

export const textDecorationStyle_decorationDashed = "decoration-dashed";

export const textDecorationStyle_decorationWavy = "decoration-wavy";

export const textDecorationThickness_decorationAuto = "decoration-auto";

export const textDecorationThickness_decorationFromFont = "decoration-from-font";

export const textDecorationThickness_decoration0 = "decoration-0";

export const textDecorationThickness_decoration1 = "decoration-1";

export const textDecorationThickness_decoration2 = "decoration-2";

export const textDecorationThickness_decoration4 = "decoration-4";

export const textDecorationThickness_decoration8 = "decoration-8";

export const textUnderlineOffset_underlineOffsetAuto = "underline-offset-auto";

export const textUnderlineOffset_underlineOffset0 = "underline-offset-0";

export const textUnderlineOffset_underlineOffset1 = "underline-offset-1";

export const textUnderlineOffset_underlineOffset2 = "underline-offset-2";

export const textUnderlineOffset_underlineOffset4 = "underline-offset-4";

export const textUnderlineOffset_underlineOffset8 = "underline-offset-8";

export const textTransform_uppercase = "uppercase";

export const textTransform_lowercase = "lowercase";

export const textTransform_capitalize = "capitalize";

export const textTransform_normalCase = "normal-case";

export const textOverflow_truncate = "truncate";

export const textOverflow_textEllipsis = "text-ellipsis";

export const textOverflow_textClip = "text-clip";

export const textWrap_textWrap = "text-wrap";

export const textWrap_textNowrap = "text-nowrap";

export const textWrap_textBalance = "text-balance";

export const textWrap_textPretty = "text-pretty";

export const whitespace_whitespaceNormal = "whitespace-normal";

export const whitespace_whitespaceNowrap = "whitespace-nowrap";

export const whitespace_whitespacePre = "whitespace-pre";

export const whitespace_whitespacePreLine = "whitespace-pre-line";

export const whitespace_whitespacePreWrap = "whitespace-pre-wrap";

export const whitespace_whitespaceBreakSpaces = "whitespace-break-spaces";

export const wordBreak_breakNormal = "break-normal";

export const wordBreak_breakWords = "break-words";

export const wordBreak_breakAll = "break-all";

export const wordBreak_breakKeep = "break-keep";

export const hyphens_hyphensNone = "hyphens-none";

export const hyphens_hyphensManual = "hyphens-manual";

export const hyphens_hyphensAuto = "hyphens-auto";

export const fontFamily_fontSans = "font-sans";

export const fontFamily_fontSerif = "font-serif";

export const fontFamily_fontMono = "font-mono";

export const fontStyle_italic = "italic";

export const fontStyle_notItalic = "not-italic";

export const fontVariantNumeric_normalNums = "normal-nums";

export const fontVariantNumeric_ordinal = "ordinal";

export const fontVariantNumeric_slashedZero = "slashed-zero";

export const fontVariantNumeric_liningNums = "lining-nums";

export const fontVariantNumeric_oldstyleNums = "oldstyle-nums";

export const fontVariantNumeric_proportionalNums = "proportional-nums";

export const fontVariantNumeric_tabularNums = "tabular-nums";

export const fontVariantNumeric_diagonalFractions = "diagonal-fractions";

export const fontVariantNumeric_stackedFractions = "stacked-fractions";

export const listStyleType_listNone = "list-none";

export const listStyleType_listDisc = "list-disc";

export const listStyleType_listDecimal = "list-decimal";

export const listStylePosition_listInside = "list-inside";

export const listStylePosition_listOutside = "list-outside";

export const textIndent_indent0 = "indent-0";

export const textIndent_indent1 = "indent-1";

export const textIndent_indent2 = "indent-2";

export const textIndent_indent4 = "indent-4";

export const textIndent_indent6 = "indent-6";

export const textIndent_indent8 = "indent-8";

export const textIndent_indent10 = "indent-10";

export const textIndent_indent12 = "indent-12";

export const textIndent_indent16 = "indent-16";

export const textIndent_indent20 = "indent-20";

export const textIndent_indent24 = "indent-24";

export const verticalAlign_alignBaseline = "align-baseline";

export const verticalAlign_alignTop = "align-top";

export const verticalAlign_alignMiddle = "align-middle";

export const verticalAlign_alignBottom = "align-bottom";

export const verticalAlign_alignTextTop = "align-text-top";

export const verticalAlign_alignTextBottom = "align-text-bottom";

export const verticalAlign_alignSub = "align-sub";

export const verticalAlign_alignSuper = "align-super";

export const minWidth_minW0 = "min-w-0";

export const minWidth_minW1 = "min-w-1";

export const minWidth_minW2 = "min-w-2";

export const minWidth_minW3 = "min-w-3";

export const minWidth_minW4 = "min-w-4";

export const minWidth_minW5 = "min-w-5";

export const minWidth_minW6 = "min-w-6";

export const minWidth_minW8 = "min-w-8";

export const minWidth_minW10 = "min-w-10";

export const minWidth_minW12 = "min-w-12";

export const minWidth_minW16 = "min-w-16";

export const minWidth_minW20 = "min-w-20";

export const minWidth_minW24 = "min-w-24";

export const minWidth_minW32 = "min-w-32";

export const minWidth_minW40 = "min-w-40";

export const minWidth_minW48 = "min-w-48";

export const minWidth_minW56 = "min-w-56";

export const minWidth_minW64 = "min-w-64";

export const minWidth_minW72 = "min-w-72";

export const minWidth_minW80 = "min-w-80";

export const minWidth_minW96 = "min-w-96";

export const minWidth_minWFull = "min-w-full";

export const minWidth_minWMin = "min-w-min";

export const minWidth_minWMax = "min-w-max";

export const minWidth_minWFit = "min-w-fit";

export const aspectRatio_aspectAuto = "aspect-auto";

export const aspectRatio_aspectSquare = "aspect-square";

export const aspectRatio_aspectVideo = "aspect-video";

export const size_size0 = "size-0";

export const size_size1 = "size-1";

export const size_size2 = "size-2";

export const size_size3 = "size-3";

export const size_size4 = "size-4";

export const size_size5 = "size-5";

export const size_size6 = "size-6";

export const size_size7 = "size-7";

export const size_size8 = "size-8";

export const size_size9 = "size-9";

export const size_size10 = "size-10";

export const size_size11 = "size-11";

export const size_size12 = "size-12";

export const size_size14 = "size-14";

export const size_size16 = "size-16";

export const size_size20 = "size-20";

export const size_size24 = "size-24";

export const size_size28 = "size-28";

export const size_size32 = "size-32";

export const size_size36 = "size-36";

export const size_size40 = "size-40";

export const size_size44 = "size-44";

export const size_size48 = "size-48";

export const size_size52 = "size-52";

export const size_size56 = "size-56";

export const size_size60 = "size-60";

export const size_size64 = "size-64";

export const size_size72 = "size-72";

export const size_size80 = "size-80";

export const size_size96 = "size-96";

export const size_sizeAuto = "size-auto";

export const size_sizeFull = "size-full";

export const size_sizeMin = "size-min";

export const size_sizeMax = "size-max";

export const size_sizeFit = "size-fit";

export const borderStyle_borderSolid = "border-solid";

export const borderStyle_borderDashed = "border-dashed";

export const borderStyle_borderDotted = "border-dotted";

export const borderStyle_borderDouble = "border-double";

export const borderStyle_borderHidden = "border-hidden";

export const borderStyle_borderNone = "border-none";

export const border_border = "border";

export const border_border0 = "border-0";

export const border_border2 = "border-2";

export const border_border4 = "border-4";

export const border_border8 = "border-8";

export const border_borderX = "border-x";

export const border_borderX0 = "border-x-0";

export const border_borderX2 = "border-x-2";

export const border_borderX4 = "border-x-4";

export const border_borderX8 = "border-x-8";

export const border_borderY = "border-y";

export const border_borderY0 = "border-y-0";

export const border_borderY2 = "border-y-2";

export const border_borderY4 = "border-y-4";

export const border_borderY8 = "border-y-8";

export const border_borderT = "border-t";

export const border_borderT0 = "border-t-0";

export const border_borderT2 = "border-t-2";

export const border_borderT4 = "border-t-4";

export const border_borderT8 = "border-t-8";

export const border_borderR = "border-r";

export const border_borderR0 = "border-r-0";

export const border_borderR2 = "border-r-2";

export const border_borderR4 = "border-r-4";

export const border_borderR8 = "border-r-8";

export const border_borderB = "border-b";

export const border_borderB0 = "border-b-0";

export const border_borderB2 = "border-b-2";

export const border_borderB4 = "border-b-4";

export const border_borderB8 = "border-b-8";

export const border_borderL = "border-l";

export const border_borderL0 = "border-l-0";

export const border_borderL2 = "border-l-2";

export const border_borderL4 = "border-l-4";

export const border_borderL8 = "border-l-8";

export const borderColor_borderInherit = "border-inherit";

export const borderColor_borderCurrent = "border-current";

export const borderColor_borderTransparent = "border-transparent";

export const borderColor_borderBlack = "border-black";

export const borderColor_borderWhite = "border-white";

export const borderColor_borderSlate50 = "border-slate-50";

export const borderColor_borderSlate100 = "border-slate-100";

export const borderColor_borderSlate200 = "border-slate-200";

export const borderColor_borderSlate300 = "border-slate-300";

export const borderColor_borderSlate400 = "border-slate-400";

export const borderColor_borderSlate500 = "border-slate-500";

export const borderColor_borderSlate600 = "border-slate-600";

export const borderColor_borderSlate700 = "border-slate-700";

export const borderColor_borderSlate800 = "border-slate-800";

export const borderColor_borderSlate900 = "border-slate-900";

export const borderColor_borderSlate950 = "border-slate-950";

export const borderColor_borderGray50 = "border-gray-50";

export const borderColor_borderGray100 = "border-gray-100";

export const borderColor_borderGray200 = "border-gray-200";

export const borderColor_borderGray300 = "border-gray-300";

export const borderColor_borderGray400 = "border-gray-400";

export const borderColor_borderGray500 = "border-gray-500";

export const borderColor_borderGray600 = "border-gray-600";

export const borderColor_borderGray700 = "border-gray-700";

export const borderColor_borderGray800 = "border-gray-800";

export const borderColor_borderGray900 = "border-gray-900";

export const borderColor_borderGray950 = "border-gray-950";

export const borderColor_borderZinc50 = "border-zinc-50";

export const borderColor_borderZinc100 = "border-zinc-100";

export const borderColor_borderZinc200 = "border-zinc-200";

export const borderColor_borderZinc300 = "border-zinc-300";

export const borderColor_borderZinc400 = "border-zinc-400";

export const borderColor_borderZinc500 = "border-zinc-500";

export const borderColor_borderZinc600 = "border-zinc-600";

export const borderColor_borderZinc700 = "border-zinc-700";

export const borderColor_borderZinc800 = "border-zinc-800";

export const borderColor_borderZinc900 = "border-zinc-900";

export const borderColor_borderZinc950 = "border-zinc-950";

export const borderColor_borderRed50 = "border-red-50";

export const borderColor_borderRed100 = "border-red-100";

export const borderColor_borderRed200 = "border-red-200";

export const borderColor_borderRed300 = "border-red-300";

export const borderColor_borderRed400 = "border-red-400";

export const borderColor_borderRed500 = "border-red-500";

export const borderColor_borderRed600 = "border-red-600";

export const borderColor_borderRed700 = "border-red-700";

export const borderColor_borderRed800 = "border-red-800";

export const borderColor_borderRed900 = "border-red-900";

export const borderColor_borderRed950 = "border-red-950";

export const borderColor_borderOrange50 = "border-orange-50";

export const borderColor_borderOrange100 = "border-orange-100";

export const borderColor_borderOrange200 = "border-orange-200";

export const borderColor_borderOrange300 = "border-orange-300";

export const borderColor_borderOrange400 = "border-orange-400";

export const borderColor_borderOrange500 = "border-orange-500";

export const borderColor_borderOrange600 = "border-orange-600";

export const borderColor_borderOrange700 = "border-orange-700";

export const borderColor_borderOrange800 = "border-orange-800";

export const borderColor_borderOrange900 = "border-orange-900";

export const borderColor_borderOrange950 = "border-orange-950";

export const borderColor_borderYellow50 = "border-yellow-50";

export const borderColor_borderYellow100 = "border-yellow-100";

export const borderColor_borderYellow200 = "border-yellow-200";

export const borderColor_borderYellow300 = "border-yellow-300";

export const borderColor_borderYellow400 = "border-yellow-400";

export const borderColor_borderYellow500 = "border-yellow-500";

export const borderColor_borderYellow600 = "border-yellow-600";

export const borderColor_borderYellow700 = "border-yellow-700";

export const borderColor_borderYellow800 = "border-yellow-800";

export const borderColor_borderYellow900 = "border-yellow-900";

export const borderColor_borderYellow950 = "border-yellow-950";

export const borderColor_borderGreen50 = "border-green-50";

export const borderColor_borderGreen100 = "border-green-100";

export const borderColor_borderGreen200 = "border-green-200";

export const borderColor_borderGreen300 = "border-green-300";

export const borderColor_borderGreen400 = "border-green-400";

export const borderColor_borderGreen500 = "border-green-500";

export const borderColor_borderGreen600 = "border-green-600";

export const borderColor_borderGreen700 = "border-green-700";

export const borderColor_borderGreen800 = "border-green-800";

export const borderColor_borderGreen900 = "border-green-900";

export const borderColor_borderGreen950 = "border-green-950";

export const borderColor_borderBlue50 = "border-blue-50";

export const borderColor_borderBlue100 = "border-blue-100";

export const borderColor_borderBlue200 = "border-blue-200";

export const borderColor_borderBlue300 = "border-blue-300";

export const borderColor_borderBlue400 = "border-blue-400";

export const borderColor_borderBlue500 = "border-blue-500";

export const borderColor_borderBlue600 = "border-blue-600";

export const borderColor_borderBlue700 = "border-blue-700";

export const borderColor_borderBlue800 = "border-blue-800";

export const borderColor_borderBlue900 = "border-blue-900";

export const borderColor_borderBlue950 = "border-blue-950";

export const borderColor_borderIndigo50 = "border-indigo-50";

export const borderColor_borderIndigo100 = "border-indigo-100";

export const borderColor_borderIndigo200 = "border-indigo-200";

export const borderColor_borderIndigo300 = "border-indigo-300";

export const borderColor_borderIndigo400 = "border-indigo-400";

export const borderColor_borderIndigo500 = "border-indigo-500";

export const borderColor_borderIndigo600 = "border-indigo-600";

export const borderColor_borderIndigo700 = "border-indigo-700";

export const borderColor_borderIndigo800 = "border-indigo-800";

export const borderColor_borderIndigo900 = "border-indigo-900";

export const borderColor_borderIndigo950 = "border-indigo-950";

export const borderColor_borderPurple50 = "border-purple-50";

export const borderColor_borderPurple100 = "border-purple-100";

export const borderColor_borderPurple200 = "border-purple-200";

export const borderColor_borderPurple300 = "border-purple-300";

export const borderColor_borderPurple400 = "border-purple-400";

export const borderColor_borderPurple500 = "border-purple-500";

export const borderColor_borderPurple600 = "border-purple-600";

export const borderColor_borderPurple700 = "border-purple-700";

export const borderColor_borderPurple800 = "border-purple-800";

export const borderColor_borderPurple900 = "border-purple-900";

export const borderColor_borderPurple950 = "border-purple-950";

export const borderColor_borderPink50 = "border-pink-50";

export const borderColor_borderPink100 = "border-pink-100";

export const borderColor_borderPink200 = "border-pink-200";

export const borderColor_borderPink300 = "border-pink-300";

export const borderColor_borderPink400 = "border-pink-400";

export const borderColor_borderPink500 = "border-pink-500";

export const borderColor_borderPink600 = "border-pink-600";

export const borderColor_borderPink700 = "border-pink-700";

export const borderColor_borderPink800 = "border-pink-800";

export const borderColor_borderPink900 = "border-pink-900";

export const borderColor_borderPink950 = "border-pink-950";

export const divide_divideX = "divide-x";

export const divide_divideX0 = "divide-x-0";

export const divide_divideX2 = "divide-x-2";

export const divide_divideX4 = "divide-x-4";

export const divide_divideX8 = "divide-x-8";

export const divide_divideY = "divide-y";

export const divide_divideY0 = "divide-y-0";

export const divide_divideY2 = "divide-y-2";

export const divide_divideY4 = "divide-y-4";

export const divide_divideY8 = "divide-y-8";

export const divide_divideXReverse = "divide-x-reverse";

export const divide_divideYReverse = "divide-y-reverse";

export const divide_divideSolid = "divide-solid";

export const divide_divideDashed = "divide-dashed";

export const divide_divideDotted = "divide-dotted";

export const divide_divideDouble = "divide-double";

export const divide_divideNone = "divide-none";

export const ring_ring = "ring";

export const ring_ring0 = "ring-0";

export const ring_ring1 = "ring-1";

export const ring_ring2 = "ring-2";

export const ring_ring4 = "ring-4";

export const ring_ring8 = "ring-8";

export const ring_ringInset = "ring-inset";

export const ringColor_ringInherit = "ring-inherit";

export const ringColor_ringCurrent = "ring-current";

export const ringColor_ringTransparent = "ring-transparent";

export const ringColor_ringBlack = "ring-black";

export const ringColor_ringWhite = "ring-white";

export const ringColor_ringSlate50 = "ring-slate-50";

export const ringColor_ringSlate100 = "ring-slate-100";

export const ringColor_ringSlate200 = "ring-slate-200";

export const ringColor_ringSlate300 = "ring-slate-300";

export const ringColor_ringSlate400 = "ring-slate-400";

export const ringColor_ringSlate500 = "ring-slate-500";

export const ringColor_ringSlate600 = "ring-slate-600";

export const ringColor_ringSlate700 = "ring-slate-700";

export const ringColor_ringSlate800 = "ring-slate-800";

export const ringColor_ringSlate900 = "ring-slate-900";

export const ringColor_ringGray50 = "ring-gray-50";

export const ringColor_ringGray100 = "ring-gray-100";

export const ringColor_ringGray200 = "ring-gray-200";

export const ringColor_ringGray300 = "ring-gray-300";

export const ringColor_ringGray400 = "ring-gray-400";

export const ringColor_ringGray500 = "ring-gray-500";

export const ringColor_ringGray600 = "ring-gray-600";

export const ringColor_ringGray700 = "ring-gray-700";

export const ringColor_ringGray800 = "ring-gray-800";

export const ringColor_ringGray900 = "ring-gray-900";

export const ringColor_ringBlue50 = "ring-blue-50";

export const ringColor_ringBlue100 = "ring-blue-100";

export const ringColor_ringBlue200 = "ring-blue-200";

export const ringColor_ringBlue300 = "ring-blue-300";

export const ringColor_ringBlue400 = "ring-blue-400";

export const ringColor_ringBlue500 = "ring-blue-500";

export const ringColor_ringBlue600 = "ring-blue-600";

export const ringColor_ringBlue700 = "ring-blue-700";

export const ringColor_ringBlue800 = "ring-blue-800";

export const ringColor_ringBlue900 = "ring-blue-900";

export const ringColor_ringRed50 = "ring-red-50";

export const ringColor_ringRed100 = "ring-red-100";

export const ringColor_ringRed200 = "ring-red-200";

export const ringColor_ringRed300 = "ring-red-300";

export const ringColor_ringRed400 = "ring-red-400";

export const ringColor_ringRed500 = "ring-red-500";

export const ringColor_ringRed600 = "ring-red-600";

export const ringColor_ringRed700 = "ring-red-700";

export const ringColor_ringRed800 = "ring-red-800";

export const ringColor_ringRed900 = "ring-red-900";

export const ringColor_ringGreen50 = "ring-green-50";

export const ringColor_ringGreen100 = "ring-green-100";

export const ringColor_ringGreen200 = "ring-green-200";

export const ringColor_ringGreen300 = "ring-green-300";

export const ringColor_ringGreen400 = "ring-green-400";

export const ringColor_ringGreen500 = "ring-green-500";

export const ringColor_ringGreen600 = "ring-green-600";

export const ringColor_ringGreen700 = "ring-green-700";

export const ringColor_ringGreen800 = "ring-green-800";

export const ringColor_ringGreen900 = "ring-green-900";

export const ringOffsetWidth_ringOffset0 = "ring-offset-0";

export const ringOffsetWidth_ringOffset1 = "ring-offset-1";

export const ringOffsetWidth_ringOffset2 = "ring-offset-2";

export const ringOffsetWidth_ringOffset4 = "ring-offset-4";

export const ringOffsetWidth_ringOffset8 = "ring-offset-8";

export const outlineWidth_outlineWidth0 = "outline-0";

export const outlineWidth_outlineWidth1 = "outline-1";

export const outlineWidth_outlineWidth2 = "outline-2";

export const outlineWidth_outlineWidth4 = "outline-4";

export const outlineWidth_outlineWidth8 = "outline-8";

export const outlineOffset_outlineOffset0 = "outline-offset-0";

export const outlineOffset_outlineOffset1 = "outline-offset-1";

export const outlineOffset_outlineOffset2 = "outline-offset-2";

export const outlineOffset_outlineOffset4 = "outline-offset-4";

export const outlineOffset_outlineOffset8 = "outline-offset-8";

export const scale_scale0 = "scale-0";

export const scale_scale50 = "scale-50";

export const scale_scale75 = "scale-75";

export const scale_scale90 = "scale-90";

export const scale_scale95 = "scale-95";

export const scale_scale100 = "scale-100";

export const scale_scale105 = "scale-105";

export const scale_scale110 = "scale-110";

export const scale_scale125 = "scale-125";

export const scale_scale150 = "scale-150";

export const scale_scaleX0 = "scale-x-0";

export const scale_scaleX50 = "scale-x-50";

export const scale_scaleX75 = "scale-x-75";

export const scale_scaleX90 = "scale-x-90";

export const scale_scaleX95 = "scale-x-95";

export const scale_scaleX100 = "scale-x-100";

export const scale_scaleX105 = "scale-x-105";

export const scale_scaleX110 = "scale-x-110";

export const scale_scaleX125 = "scale-x-125";

export const scale_scaleX150 = "scale-x-150";

export const scale_scaleY0 = "scale-y-0";

export const scale_scaleY50 = "scale-y-50";

export const scale_scaleY75 = "scale-y-75";

export const scale_scaleY90 = "scale-y-90";

export const scale_scaleY95 = "scale-y-95";

export const scale_scaleY100 = "scale-y-100";

export const scale_scaleY105 = "scale-y-105";

export const scale_scaleY110 = "scale-y-110";

export const scale_scaleY125 = "scale-y-125";

export const scale_scaleY150 = "scale-y-150";

export const rotate_rotate0 = "rotate-0";

export const rotate_rotate1 = "rotate-1";

export const rotate_rotate2 = "rotate-2";

export const rotate_rotate3 = "rotate-3";

export const rotate_rotate6 = "rotate-6";

export const rotate_rotate12 = "rotate-12";

export const rotate_rotate45 = "rotate-45";

export const rotate_rotate90 = "rotate-90";

export const rotate_rotate180 = "rotate-180";

export const rotate_$002Drotate1 = "-rotate-1";

export const rotate_$002Drotate2 = "-rotate-2";

export const rotate_$002Drotate3 = "-rotate-3";

export const rotate_$002Drotate6 = "-rotate-6";

export const rotate_$002Drotate12 = "-rotate-12";

export const rotate_$002Drotate45 = "-rotate-45";

export const rotate_$002Drotate90 = "-rotate-90";

export const rotate_$002Drotate180 = "-rotate-180";

export const translate_translateX0 = "translate-x-0";

export const translate_translateX1 = "translate-x-1";

export const translate_translateX2 = "translate-x-2";

export const translate_translateX3 = "translate-x-3";

export const translate_translateX4 = "translate-x-4";

export const translate_translateX5 = "translate-x-5";

export const translate_translateX6 = "translate-x-6";

export const translate_translateX8 = "translate-x-8";

export const translate_translateX10 = "translate-x-10";

export const translate_translateX12 = "translate-x-12";

export const translate_translateX16 = "translate-x-16";

export const translate_translateX20 = "translate-x-20";

export const translate_translateX24 = "translate-x-24";

export const translate_translateX32 = "translate-x-32";

export const translate_translateX40 = "translate-x-40";

export const translate_translateX48 = "translate-x-48";

export const translate_translateX56 = "translate-x-56";

export const translate_translateX64 = "translate-x-64";

export const translate_translateX1$002F2 = "translate-x-1/2";

export const translate_translateX1$002F3 = "translate-x-1/3";

export const translate_translateX2$002F3 = "translate-x-2/3";

export const translate_translateX1$002F4 = "translate-x-1/4";

export const translate_translateX3$002F4 = "translate-x-3/4";

export const translate_translateXFull = "translate-x-full";

export const translate_$002DtranslateX1 = "-translate-x-1";

export const translate_$002DtranslateX2 = "-translate-x-2";

export const translate_$002DtranslateX4 = "-translate-x-4";

export const translate_$002DtranslateX1$002F2 = "-translate-x-1/2";

export const translate_$002DtranslateXFull = "-translate-x-full";

export const translate_translateY0 = "translate-y-0";

export const translate_translateY1 = "translate-y-1";

export const translate_translateY2 = "translate-y-2";

export const translate_translateY3 = "translate-y-3";

export const translate_translateY4 = "translate-y-4";

export const translate_translateY5 = "translate-y-5";

export const translate_translateY6 = "translate-y-6";

export const translate_translateY8 = "translate-y-8";

export const translate_translateY10 = "translate-y-10";

export const translate_translateY12 = "translate-y-12";

export const translate_translateY16 = "translate-y-16";

export const translate_translateY20 = "translate-y-20";

export const translate_translateY24 = "translate-y-24";

export const translate_translateY32 = "translate-y-32";

export const translate_translateY40 = "translate-y-40";

export const translate_translateY48 = "translate-y-48";

export const translate_translateY56 = "translate-y-56";

export const translate_translateY64 = "translate-y-64";

export const translate_translateY1$002F2 = "translate-y-1/2";

export const translate_translateY1$002F3 = "translate-y-1/3";

export const translate_translateY2$002F3 = "translate-y-2/3";

export const translate_translateY1$002F4 = "translate-y-1/4";

export const translate_translateY3$002F4 = "translate-y-3/4";

export const translate_translateYFull = "translate-y-full";

export const translate_$002DtranslateY1 = "-translate-y-1";

export const translate_$002DtranslateY2 = "-translate-y-2";

export const translate_$002DtranslateY4 = "-translate-y-4";

export const translate_$002DtranslateY1$002F2 = "-translate-y-1/2";

export const translate_$002DtranslateYFull = "-translate-y-full";

export const skew_skewX0 = "skew-x-0";

export const skew_skewX1 = "skew-x-1";

export const skew_skewX2 = "skew-x-2";

export const skew_skewX3 = "skew-x-3";

export const skew_skewX6 = "skew-x-6";

export const skew_skewX12 = "skew-x-12";

export const skew_$002DskewX1 = "-skew-x-1";

export const skew_$002DskewX2 = "-skew-x-2";

export const skew_$002DskewX3 = "-skew-x-3";

export const skew_$002DskewX6 = "-skew-x-6";

export const skew_$002DskewX12 = "-skew-x-12";

export const skew_skewY0 = "skew-y-0";

export const skew_skewY1 = "skew-y-1";

export const skew_skewY2 = "skew-y-2";

export const skew_skewY3 = "skew-y-3";

export const skew_skewY6 = "skew-y-6";

export const skew_skewY12 = "skew-y-12";

export const skew_$002DskewY1 = "-skew-y-1";

export const skew_$002DskewY2 = "-skew-y-2";

export const skew_$002DskewY3 = "-skew-y-3";

export const skew_$002DskewY6 = "-skew-y-6";

export const skew_$002DskewY12 = "-skew-y-12";

export const transformOrigin_originCenter = "origin-center";

export const transformOrigin_originTop = "origin-top";

export const transformOrigin_originTopRight = "origin-top-right";

export const transformOrigin_originRight = "origin-right";

export const transformOrigin_originBottomRight = "origin-bottom-right";

export const transformOrigin_originBottom = "origin-bottom";

export const transformOrigin_originBottomLeft = "origin-bottom-left";

export const transformOrigin_originLeft = "origin-left";

export const transformOrigin_originTopLeft = "origin-top-left";

export const transition_transitionNone = "transition-none";

export const transition_transitionAll = "transition-all";

export const transition_transition = "transition";

export const transition_transitionColors = "transition-colors";

export const transition_transitionOpacity = "transition-opacity";

export const transition_transitionShadow = "transition-shadow";

export const transition_transitionTransform = "transition-transform";

export const duration_duration0 = "duration-0";

export const duration_duration75 = "duration-75";

export const duration_duration100 = "duration-100";

export const duration_duration150 = "duration-150";

export const duration_duration200 = "duration-200";

export const duration_duration300 = "duration-300";

export const duration_duration500 = "duration-500";

export const duration_duration700 = "duration-700";

export const duration_duration1000 = "duration-1000";

export const ease_easeLinear = "ease-linear";

export const ease_easeIn = "ease-in";

export const ease_easeOut = "ease-out";

export const ease_easeInOut = "ease-in-out";

export const delay_delay0 = "delay-0";

export const delay_delay75 = "delay-75";

export const delay_delay100 = "delay-100";

export const delay_delay150 = "delay-150";

export const delay_delay200 = "delay-200";

export const delay_delay300 = "delay-300";

export const delay_delay500 = "delay-500";

export const delay_delay700 = "delay-700";

export const delay_delay1000 = "delay-1000";

export const animation_animateNone = "animate-none";

export const animation_animateSpin = "animate-spin";

export const animation_animatePing = "animate-ping";

export const animation_animatePulse = "animate-pulse";

export const animation_animateBounce = "animate-bounce";

export const blur_blurNone = "blur-none";

export const blur_blurSm = "blur-sm";

export const blur_blur = "blur";

export const blur_blurMd = "blur-md";

export const blur_blurLg = "blur-lg";

export const blur_blurXl = "blur-xl";

export const blur_blur2Xl = "blur-2xl";

export const blur_blur3Xl = "blur-3xl";

export const brightness_brightness0 = "brightness-0";

export const brightness_brightness50 = "brightness-50";

export const brightness_brightness75 = "brightness-75";

export const brightness_brightness90 = "brightness-90";

export const brightness_brightness95 = "brightness-95";

export const brightness_brightness100 = "brightness-100";

export const brightness_brightness105 = "brightness-105";

export const brightness_brightness110 = "brightness-110";

export const brightness_brightness125 = "brightness-125";

export const brightness_brightness150 = "brightness-150";

export const brightness_brightness200 = "brightness-200";

export const contrast_contrast0 = "contrast-0";

export const contrast_contrast50 = "contrast-50";

export const contrast_contrast75 = "contrast-75";

export const contrast_contrast100 = "contrast-100";

export const contrast_contrast125 = "contrast-125";

export const contrast_contrast150 = "contrast-150";

export const contrast_contrast200 = "contrast-200";

export const grayscale_grayscale0 = "grayscale-0";

export const grayscale_grayscale = "grayscale";

export const hueRotate_hueRotate0 = "hue-rotate-0";

export const hueRotate_hueRotate15 = "hue-rotate-15";

export const hueRotate_hueRotate30 = "hue-rotate-30";

export const hueRotate_hueRotate60 = "hue-rotate-60";

export const hueRotate_hueRotate90 = "hue-rotate-90";

export const hueRotate_hueRotate180 = "hue-rotate-180";

export const hueRotate_$002DhueRotate15 = "-hue-rotate-15";

export const hueRotate_$002DhueRotate30 = "-hue-rotate-30";

export const hueRotate_$002DhueRotate60 = "-hue-rotate-60";

export const hueRotate_$002DhueRotate90 = "-hue-rotate-90";

export const hueRotate_$002DhueRotate180 = "-hue-rotate-180";

export const invert_invert0 = "invert-0";

export const invert_invert = "invert";

export const saturate_saturate0 = "saturate-0";

export const saturate_saturate50 = "saturate-50";

export const saturate_saturate100 = "saturate-100";

export const saturate_saturate150 = "saturate-150";

export const saturate_saturate200 = "saturate-200";

export const sepia_sepia0 = "sepia-0";

export const sepia_sepia = "sepia";

export const dropShadow_dropShadowSm = "drop-shadow-sm";

export const dropShadow_dropShadow = "drop-shadow";

export const dropShadow_dropShadowMd = "drop-shadow-md";

export const dropShadow_dropShadowLg = "drop-shadow-lg";

export const dropShadow_dropShadowXl = "drop-shadow-xl";

export const dropShadow_dropShadow2Xl = "drop-shadow-2xl";

export const dropShadow_dropShadowNone = "drop-shadow-none";

export const backdropBlur_backdropBlurNone = "backdrop-blur-none";

export const backdropBlur_backdropBlurSm = "backdrop-blur-sm";

export const backdropBlur_backdropBlur = "backdrop-blur";

export const backdropBlur_backdropBlurMd = "backdrop-blur-md";

export const backdropBlur_backdropBlurLg = "backdrop-blur-lg";

export const backdropBlur_backdropBlurXl = "backdrop-blur-xl";

export const backdropBlur_backdropBlur2Xl = "backdrop-blur-2xl";

export const backdropBlur_backdropBlur3Xl = "backdrop-blur-3xl";

export const backdropBrightness_backdropBrightness0 = "backdrop-brightness-0";

export const backdropBrightness_backdropBrightness50 = "backdrop-brightness-50";

export const backdropBrightness_backdropBrightness75 = "backdrop-brightness-75";

export const backdropBrightness_backdropBrightness90 = "backdrop-brightness-90";

export const backdropBrightness_backdropBrightness95 = "backdrop-brightness-95";

export const backdropBrightness_backdropBrightness100 = "backdrop-brightness-100";

export const backdropBrightness_backdropBrightness105 = "backdrop-brightness-105";

export const backdropBrightness_backdropBrightness110 = "backdrop-brightness-110";

export const backdropBrightness_backdropBrightness125 = "backdrop-brightness-125";

export const backdropBrightness_backdropBrightness150 = "backdrop-brightness-150";

export const backdropBrightness_backdropBrightness200 = "backdrop-brightness-200";

export const backdropContrast_backdropContrast0 = "backdrop-contrast-0";

export const backdropContrast_backdropContrast50 = "backdrop-contrast-50";

export const backdropContrast_backdropContrast75 = "backdrop-contrast-75";

export const backdropContrast_backdropContrast100 = "backdrop-contrast-100";

export const backdropContrast_backdropContrast125 = "backdrop-contrast-125";

export const backdropContrast_backdropContrast150 = "backdrop-contrast-150";

export const backdropContrast_backdropContrast200 = "backdrop-contrast-200";

export const backdropGrayscale_backdropGrayscale0 = "backdrop-grayscale-0";

export const backdropGrayscale_backdropGrayscale = "backdrop-grayscale";

export const backdropInvert_backdropInvert0 = "backdrop-invert-0";

export const backdropInvert_backdropInvert = "backdrop-invert";

export const backdropOpacity_backdropOpacity0 = "backdrop-opacity-0";

export const backdropOpacity_backdropOpacity5 = "backdrop-opacity-5";

export const backdropOpacity_backdropOpacity10 = "backdrop-opacity-10";

export const backdropOpacity_backdropOpacity20 = "backdrop-opacity-20";

export const backdropOpacity_backdropOpacity25 = "backdrop-opacity-25";

export const backdropOpacity_backdropOpacity30 = "backdrop-opacity-30";

export const backdropOpacity_backdropOpacity40 = "backdrop-opacity-40";

export const backdropOpacity_backdropOpacity50 = "backdrop-opacity-50";

export const backdropOpacity_backdropOpacity60 = "backdrop-opacity-60";

export const backdropOpacity_backdropOpacity70 = "backdrop-opacity-70";

export const backdropOpacity_backdropOpacity75 = "backdrop-opacity-75";

export const backdropOpacity_backdropOpacity80 = "backdrop-opacity-80";

export const backdropOpacity_backdropOpacity90 = "backdrop-opacity-90";

export const backdropOpacity_backdropOpacity95 = "backdrop-opacity-95";

export const backdropOpacity_backdropOpacity100 = "backdrop-opacity-100";

export const backdropSaturate_backdropSaturate0 = "backdrop-saturate-0";

export const backdropSaturate_backdropSaturate50 = "backdrop-saturate-50";

export const backdropSaturate_backdropSaturate100 = "backdrop-saturate-100";

export const backdropSaturate_backdropSaturate150 = "backdrop-saturate-150";

export const backdropSaturate_backdropSaturate200 = "backdrop-saturate-200";

export const backdropSepia_backdropSepia0 = "backdrop-sepia-0";

export const backdropSepia_backdropSepia = "backdrop-sepia";

export const cursor_cursorAuto = "cursor-auto";

export const cursor_cursorDefault = "cursor-default";

export const cursor_cursorPointer = "cursor-pointer";

export const cursor_cursorWait = "cursor-wait";

export const cursor_cursorText = "cursor-text";

export const cursor_cursorMove = "cursor-move";

export const cursor_cursorHelp = "cursor-help";

export const cursor_cursorNotAllowed = "cursor-not-allowed";

export const cursor_cursorNone = "cursor-none";

export const cursor_cursorContextMenu = "cursor-context-menu";

export const cursor_cursorProgress = "cursor-progress";

export const cursor_cursorCell = "cursor-cell";

export const cursor_cursorCrosshair = "cursor-crosshair";

export const cursor_cursorVerticalText = "cursor-vertical-text";

export const cursor_cursorAlias = "cursor-alias";

export const cursor_cursorCopy = "cursor-copy";

export const cursor_cursorNoDrop = "cursor-no-drop";

export const cursor_cursorGrab = "cursor-grab";

export const cursor_cursorGrabbing = "cursor-grabbing";

export const cursor_cursorAllScroll = "cursor-all-scroll";

export const cursor_cursorColResize = "cursor-col-resize";

export const cursor_cursorRowResize = "cursor-row-resize";

export const cursor_cursorNResize = "cursor-n-resize";

export const cursor_cursorEResize = "cursor-e-resize";

export const cursor_cursorSResize = "cursor-s-resize";

export const cursor_cursorWResize = "cursor-w-resize";

export const cursor_cursorNeResize = "cursor-ne-resize";

export const cursor_cursorNwResize = "cursor-nw-resize";

export const cursor_cursorSeResize = "cursor-se-resize";

export const cursor_cursorSwResize = "cursor-sw-resize";

export const cursor_cursorEwResize = "cursor-ew-resize";

export const cursor_cursorNsResize = "cursor-ns-resize";

export const cursor_cursorNeswResize = "cursor-nesw-resize";

export const cursor_cursorNwseResize = "cursor-nwse-resize";

export const cursor_cursorZoomIn = "cursor-zoom-in";

export const cursor_cursorZoomOut = "cursor-zoom-out";

export const pointerEvents_pointerEventsNone = "pointer-events-none";

export const pointerEvents_pointerEventsAuto = "pointer-events-auto";

export const resize_resizeNone = "resize-none";

export const resize_resize = "resize";

export const resize_resizeY = "resize-y";

export const resize_resizeX = "resize-x";

export const userSelect_selectNone = "select-none";

export const userSelect_selectText = "select-text";

export const userSelect_selectAll = "select-all";

export const userSelect_selectAuto = "select-auto";

export const touchAction_touchAuto = "touch-auto";

export const touchAction_touchNone = "touch-none";

export const touchAction_touchPanX = "touch-pan-x";

export const touchAction_touchPanLeft = "touch-pan-left";

export const touchAction_touchPanRight = "touch-pan-right";

export const touchAction_touchPanY = "touch-pan-y";

export const touchAction_touchPanUp = "touch-pan-up";

export const touchAction_touchPanDown = "touch-pan-down";

export const touchAction_touchPinchZoom = "touch-pinch-zoom";

export const touchAction_touchManipulation = "touch-manipulation";

export const scrollBehavior_scrollAuto = "scroll-auto";

export const scrollBehavior_scrollSmooth = "scroll-smooth";

export const scrollSnapAlign_snapStart = "snap-start";

export const scrollSnapAlign_snapEnd = "snap-end";

export const scrollSnapAlign_snapCenter = "snap-center";

export const scrollSnapAlign_snapAlignNone = "snap-align-none";

export const scrollSnapStop_snapNormal = "snap-normal";

export const scrollSnapStop_snapAlways = "snap-always";

export const scrollSnapType_snapNone = "snap-none";

export const scrollSnapType_snapX = "snap-x";

export const scrollSnapType_snapY = "snap-y";

export const scrollSnapType_snapBoth = "snap-both";

export const scrollSnapType_snapMandatory = "snap-mandatory";

export const scrollSnapType_snapProximity = "snap-proximity";

export const willChange_willChangeAuto = "will-change-auto";

export const willChange_willChangeScroll = "will-change-scroll";

export const willChange_willChangeContents = "will-change-contents";

export const willChange_willChangeTransform = "will-change-transform";

export const appearance_appearanceNone = "appearance-none";

export const appearance_appearanceAuto = "appearance-auto";

export const caretColor_caretInherit = "caret-inherit";

export const caretColor_caretCurrent = "caret-current";

export const caretColor_caretTransparent = "caret-transparent";

export const caretColor_caretBlack = "caret-black";

export const caretColor_caretWhite = "caret-white";

export const caretColor_caretSlate500 = "caret-slate-500";

export const caretColor_caretGray500 = "caret-gray-500";

export const caretColor_caretRed500 = "caret-red-500";

export const caretColor_caretOrange500 = "caret-orange-500";

export const caretColor_caretYellow500 = "caret-yellow-500";

export const caretColor_caretGreen500 = "caret-green-500";

export const caretColor_caretBlue500 = "caret-blue-500";

export const caretColor_caretIndigo500 = "caret-indigo-500";

export const caretColor_caretPurple500 = "caret-purple-500";

export const caretColor_caretPink500 = "caret-pink-500";

export const accentColor_accentInherit = "accent-inherit";

export const accentColor_accentCurrent = "accent-current";

export const accentColor_accentTransparent = "accent-transparent";

export const accentColor_accentBlack = "accent-black";

export const accentColor_accentWhite = "accent-white";

export const accentColor_accentAuto = "accent-auto";

export const accentColor_accentSlate500 = "accent-slate-500";

export const accentColor_accentGray500 = "accent-gray-500";

export const accentColor_accentRed500 = "accent-red-500";

export const accentColor_accentOrange500 = "accent-orange-500";

export const accentColor_accentYellow500 = "accent-yellow-500";

export const accentColor_acretGreen500 = "accent-green-500";

export const accentColor_accentBlue500 = "accent-blue-500";

export const accentColor_accentIndigo500 = "accent-indigo-500";

export const accentColor_accentPurple500 = "accent-purple-500";

export const accentColor_accentPink500 = "accent-pink-500";

export const fill_fillNone = "fill-none";

export const fill_fillInherit = "fill-inherit";

export const fill_fillCurrent = "fill-current";

export const fill_fillTransparent = "fill-transparent";

export const fill_fillBlack = "fill-black";

export const fill_fillWhite = "fill-white";

export const fill_fillSlate50 = "fill-slate-50";

export const fill_fillSlate100 = "fill-slate-100";

export const fill_fillSlate200 = "fill-slate-200";

export const fill_fillSlate300 = "fill-slate-300";

export const fill_fillSlate400 = "fill-slate-400";

export const fill_fillSlate500 = "fill-slate-500";

export const fill_fillSlate600 = "fill-slate-600";

export const fill_fillSlate700 = "fill-slate-700";

export const fill_fillSlate800 = "fill-slate-800";

export const fill_fillSlate900 = "fill-slate-900";

export const fill_fillGray500 = "fill-gray-500";

export const fill_fillRed500 = "fill-red-500";

export const fill_fillOrange500 = "fill-orange-500";

export const fill_fillYellow500 = "fill-yellow-500";

export const fill_fillGreen500 = "fill-green-500";

export const fill_fillBlue500 = "fill-blue-500";

export const fill_fillIndigo500 = "fill-indigo-500";

export const fill_fillPurple500 = "fill-purple-500";

export const fill_fillPink500 = "fill-pink-500";

export const stroke_strokeNone = "stroke-none";

export const stroke_strokeInherit = "stroke-inherit";

export const stroke_strokeCurrent = "stroke-current";

export const stroke_strokeTransparent = "stroke-transparent";

export const stroke_strokeBlack = "stroke-black";

export const stroke_strokeWhite = "stroke-white";

export const stroke_strokeSlate500 = "stroke-slate-500";

export const stroke_strokeGray500 = "stroke-gray-500";

export const stroke_strokeRed500 = "stroke-red-500";

export const stroke_strokeOrange500 = "stroke-orange-500";

export const stroke_strokeYellow500 = "stroke-yellow-500";

export const stroke_strokeGreen500 = "stroke-green-500";

export const stroke_strokeBlue500 = "stroke-blue-500";

export const stroke_strokeIndigo500 = "stroke-indigo-500";

export const stroke_strokePurple500 = "stroke-purple-500";

export const stroke_strokePink500 = "stroke-pink-500";

export const strokeWidth_stroke0 = "stroke-0";

export const strokeWidth_stroke1 = "stroke-1";

export const strokeWidth_stroke2 = "stroke-2";

export const borderCollapse_borderCollapse = "border-collapse";

export const borderCollapse_borderSeparate = "border-separate";

export const borderSpacing_borderSpacing0 = "border-spacing-0";

export const borderSpacing_borderSpacing1 = "border-spacing-1";

export const borderSpacing_borderSpacing2 = "border-spacing-2";

export const borderSpacing_borderSpacing3 = "border-spacing-3";

export const borderSpacing_borderSpacing4 = "border-spacing-4";

export const borderSpacing_borderSpacing5 = "border-spacing-5";

export const borderSpacing_borderSpacing6 = "border-spacing-6";

export const borderSpacing_borderSpacing8 = "border-spacing-8";

export const borderSpacing_borderSpacing10 = "border-spacing-10";

export const borderSpacing_borderSpacing12 = "border-spacing-12";

export const borderSpacing_borderSpacingX0 = "border-spacing-x-0";

export const borderSpacing_borderSpacingX1 = "border-spacing-x-1";

export const borderSpacing_borderSpacingX2 = "border-spacing-x-2";

export const borderSpacing_borderSpacingX4 = "border-spacing-x-4";

export const borderSpacing_borderSpacingY0 = "border-spacing-y-0";

export const borderSpacing_borderSpacingY1 = "border-spacing-y-1";

export const borderSpacing_borderSpacingY2 = "border-spacing-y-2";

export const borderSpacing_borderSpacingY4 = "border-spacing-y-4";

export const tableLayout_tableAuto = "table-auto";

export const tableLayout_tableFixed = "table-fixed";

export const captionSide_captionTop = "caption-top";

export const captionSide_captionBottom = "caption-bottom";

export const objectFit_objectContain = "object-contain";

export const objectFit_objectCover = "object-cover";

export const objectFit_objectFill = "object-fill";

export const objectFit_objectNone = "object-none";

export const objectFit_objectScaleDown = "object-scale-down";

export const objectPosition_objectBottom = "object-bottom";

export const objectPosition_objectCenter = "object-center";

export const objectPosition_objectLeft = "object-left";

export const objectPosition_objectLeftBottom = "object-left-bottom";

export const objectPosition_objectLeftTop = "object-left-top";

export const objectPosition_objectRight = "object-right";

export const objectPosition_objectRightBottom = "object-right-bottom";

export const objectPosition_objectRightTop = "object-right-top";

export const objectPosition_objectTop = "object-top";

export const overscrollBehavior_overscrollAuto = "overscroll-auto";

export const overscrollBehavior_overscrollContain = "overscroll-contain";

export const overscrollBehavior_overscrollNone = "overscroll-none";

export const overscrollBehavior_overscrollXAuto = "overscroll-x-auto";

export const overscrollBehavior_overscrollXContain = "overscroll-x-contain";

export const overscrollBehavior_overscrollXNone = "overscroll-x-none";

export const overscrollBehavior_overscrollYAuto = "overscroll-y-auto";

export const overscrollBehavior_overscrollYContain = "overscroll-y-contain";

export const overscrollBehavior_overscrollYNone = "overscroll-y-none";

export const columns_columns1 = "columns-1";

export const columns_columns2 = "columns-2";

export const columns_columns3 = "columns-3";

export const columns_columns4 = "columns-4";

export const columns_columns5 = "columns-5";

export const columns_columns6 = "columns-6";

export const columns_columns7 = "columns-7";

export const columns_columns8 = "columns-8";

export const columns_columns9 = "columns-9";

export const columns_columns10 = "columns-10";

export const columns_columns11 = "columns-11";

export const columns_columns12 = "columns-12";

export const columns_columnsAuto = "columns-auto";

export const columns_columnsXs = "columns-xs";

export const columns_columnsSm = "columns-sm";

export const columns_columnsMd = "columns-md";

export const columns_columnsLg = "columns-lg";

export const columns_columnsXl = "columns-xl";

export const columns_columns2Xl = "columns-2xl";

export const columns_columns3Xl = "columns-3xl";

export const breakAfter_breakAfterAuto = "break-after-auto";

export const breakAfter_breakAfterAvoid = "break-after-avoid";

export const breakAfter_breakAfterAll = "break-after-all";

export const breakAfter_breakAfterAvoidPage = "break-after-avoid-page";

export const breakAfter_breakAfterPage = "break-after-page";

export const breakAfter_breakAfterLeft = "break-after-left";

export const breakAfter_breakAfterRight = "break-after-right";

export const breakAfter_breakAfterColumn = "break-after-column";

export const breakBefore_breakBeforeAuto = "break-before-auto";

export const breakBefore_breakBeforeAvoid = "break-before-avoid";

export const breakBefore_breakBeforeAll = "break-before-all";

export const breakBefore_breakBeforeAvoidPage = "break-before-avoid-page";

export const breakBefore_breakBeforePage = "break-before-page";

export const breakBefore_breakBeforeLeft = "break-before-left";

export const breakBefore_breakBeforeRight = "break-before-right";

export const breakBefore_breakBeforeColumn = "break-before-column";

export const breakInside_breakInsideAuto = "break-inside-auto";

export const breakInside_breakInsideAvoid = "break-inside-avoid";

export const breakInside_breakInsideAvoidPage = "break-inside-avoid-page";

export const breakInside_breakInsideAvoidColumn = "break-inside-avoid-column";

export const boxDecorationBreak_boxDecorationClone = "box-decoration-clone";

export const boxDecorationBreak_boxDecorationSlice = "box-decoration-slice";

export const boxSizing_boxBorder = "box-border";

export const boxSizing_boxContent = "box-content";

export const boxSizing_floatStart = "float-start";

export const boxSizing_floatEnd = "float-end";

export const boxSizing_floatRight = "float-right";

export const boxSizing_floatLeft = "float-left";

export const boxSizing_floatNone = "float-none";

export const clear_clearStart = "clear-start";

export const clear_clearEnd = "clear-end";

export const clear_clearLeft = "clear-left";

export const clear_clearRight = "clear-right";

export const clear_clearBoth = "clear-both";

export const clear_clearNone = "clear-none";

export const isolation_isolate = "isolate";

export const isolation_isolationAuto = "isolation-auto";

export const flexBasis_basis0 = "basis-0";

export const flexBasis_basis1 = "basis-1";

export const flexBasis_basis2 = "basis-2";

export const flexBasis_basis3 = "basis-3";

export const flexBasis_basis4 = "basis-4";

export const flexBasis_basis5 = "basis-5";

export const flexBasis_basis6 = "basis-6";

export const flexBasis_basis8 = "basis-8";

export const flexBasis_basis10 = "basis-10";

export const flexBasis_basis12 = "basis-12";

export const flexBasis_basis16 = "basis-16";

export const flexBasis_basis20 = "basis-20";

export const flexBasis_basis24 = "basis-24";

export const flexBasis_basis32 = "basis-32";

export const flexBasis_basis40 = "basis-40";

export const flexBasis_basis48 = "basis-48";

export const flexBasis_basis56 = "basis-56";

export const flexBasis_basis64 = "basis-64";

export const flexBasis_basisAuto = "basis-auto";

export const flexBasis_basisFull = "basis-full";

export const flexBasis_basis1$002F2 = "basis-1/2";

export const flexBasis_basis1$002F3 = "basis-1/3";

export const flexBasis_basis2$002F3 = "basis-2/3";

export const flexBasis_basis1$002F4 = "basis-1/4";

export const flexBasis_basis3$002F4 = "basis-3/4";

export const order_orderFirst = "order-first";

export const order_orderLast = "order-last";

export const order_orderNone = "order-none";

export const order_order1 = "order-1";

export const order_order2 = "order-2";

export const order_order3 = "order-3";

export const order_order4 = "order-4";

export const order_order5 = "order-5";

export const order_order6 = "order-6";

export const order_order7 = "order-7";

export const order_order8 = "order-8";

export const order_order9 = "order-9";

export const order_order10 = "order-10";

export const order_order11 = "order-11";

export const order_order12 = "order-12";

export const alignContent_contentNormal = "content-normal";

export const alignContent_contentCenter = "content-center";

export const alignContent_contentStart = "content-start";

export const alignContent_contentEnd = "content-end";

export const alignContent_contentBetween = "content-between";

export const alignContent_contentAround = "content-around";

export const alignContent_contentEvenly = "content-evenly";

export const alignContent_contentBaseline = "content-baseline";

export const alignContent_contentStretch = "content-stretch";

export const alignSelf_selfAuto = "self-auto";

export const alignSelf_selfStart = "self-start";

export const alignSelf_selfEnd = "self-end";

export const alignSelf_selfCenter = "self-center";

export const alignSelf_selfStretch = "self-stretch";

export const alignSelf_selfBaseline = "self-baseline";

export const justifySelf_justifySelfAuto = "justify-self-auto";

export const justifySelf_justifySelfStart = "justify-self-start";

export const justifySelf_justifySelfEnd = "justify-self-end";

export const justifySelf_justifySelfCenter = "justify-self-center";

export const justifySelf_justifySelfStretch = "justify-self-stretch";

export const placeContent_placeContentCenter = "place-content-center";

export const placeContent_placeContentStart = "place-content-start";

export const placeContent_placeContentEnd = "place-content-end";

export const placeContent_placeContentBetween = "place-content-between";

export const placeContent_placeContentAround = "place-content-around";

export const placeContent_placeContentEvenly = "place-content-evenly";

export const placeContent_placeContentBaseline = "place-content-baseline";

export const placeContent_placeContentStretch = "place-content-stretch";

export const placeItems_placeItemsStart = "place-items-start";

export const placeItems_placeItemsEnd = "place-items-end";

export const placeItems_placeItemsCenter = "place-items-center";

export const placeItems_placeItemsBaseline = "place-items-baseline";

export const placeItems_placeItemsStretch = "place-items-stretch";

export const placeSelf_placeSelfAuto = "place-self-auto";

export const placeSelf_placeSelfStart = "place-self-start";

export const placeSelf_placeSelfEnd = "place-self-end";

export const placeSelf_placeSelfCenter = "place-self-center";

export const placeSelf_placeSelfStretch = "place-self-stretch";

export const gridAutoFlow_gridFlowRow = "grid-flow-row";

export const gridAutoFlow_gridFlowCol = "grid-flow-col";

export const gridAutoFlow_gridFlowDense = "grid-flow-dense";

export const gridAutoFlow_gridFlowRowDense = "grid-flow-row-dense";

export const gridAutoFlow_gridFlowColDense = "grid-flow-col-dense";

export const gridAutoColumns_autoColsAuto = "auto-cols-auto";

export const gridAutoColumns_autoColsMin = "auto-cols-min";

export const gridAutoColumns_autoColsMax = "auto-cols-max";

export const gridAutoColumns_autoColsFr = "auto-cols-fr";

export const gridAutoRows_autoRowsAuto = "auto-rows-auto";

export const gridAutoRows_autoRowsMin = "auto-rows-min";

export const gridAutoRows_autoRowsMax = "auto-rows-max";

export const gridAutoRows_autoRowsFr = "auto-rows-fr";

export const gridRows_rows$002Dnone = "grid-rows-none";

export const gridRows_rows$002D1 = "grid-rows-1";

export const gridRows_rows$002D2 = "grid-rows-2";

export const gridRows_rows$002D3 = "grid-rows-3";

export const gridRows_rows$002D4 = "grid-rows-4";

export const gridRows_rows$002D5 = "grid-rows-5";

export const gridRows_rows$002D6 = "grid-rows-6";

export const gridRows_rows$002D7 = "grid-rows-7";

export const gridRows_rows$002D8 = "grid-rows-8";

export const gridRows_rows$002D9 = "grid-rows-9";

export const gridRows_rows$002D10 = "grid-rows-10";

export const gridRows_rows$002D11 = "grid-rows-11";

export const gridRows_rows$002D12 = "grid-rows-12";

export const gridRows_rowsSubgrid = "grid-rows-subgrid";

export const colStart_colStartAuto = "col-start-auto";

export const colStart_colStart1 = "col-start-1";

export const colStart_colStart2 = "col-start-2";

export const colStart_colStart3 = "col-start-3";

export const colStart_colStart4 = "col-start-4";

export const colStart_colStart5 = "col-start-5";

export const colStart_colStart6 = "col-start-6";

export const colStart_colStart7 = "col-start-7";

export const colStart_colStart8 = "col-start-8";

export const colStart_colStart9 = "col-start-9";

export const colStart_colStart10 = "col-start-10";

export const colStart_colStart11 = "col-start-11";

export const colStart_colStart12 = "col-start-12";

export const colStart_colStart13 = "col-start-13";

export const colEnd_colEndAuto = "col-end-auto";

export const colEnd_colEnd1 = "col-end-1";

export const colEnd_colEnd2 = "col-end-2";

export const colEnd_colEnd3 = "col-end-3";

export const colEnd_colEnd4 = "col-end-4";

export const colEnd_colEnd5 = "col-end-5";

export const colEnd_colEnd6 = "col-end-6";

export const colEnd_colEnd7 = "col-end-7";

export const colEnd_colEnd8 = "col-end-8";

export const colEnd_colEnd9 = "col-end-9";

export const colEnd_colEnd10 = "col-end-10";

export const colEnd_colEnd11 = "col-end-11";

export const colEnd_colEnd12 = "col-end-12";

export const colEnd_colEnd13 = "col-end-13";

export const rowStart_rowStartAuto = "row-start-auto";

export const rowStart_rowStart1 = "row-start-1";

export const rowStart_rowStart2 = "row-start-2";

export const rowStart_rowStart3 = "row-start-3";

export const rowStart_rowStart4 = "row-start-4";

export const rowStart_rowStart5 = "row-start-5";

export const rowStart_rowStart6 = "row-start-6";

export const rowStart_rowStart7 = "row-start-7";

export const rowStart_rowStart8 = "row-start-8";

export const rowStart_rowStart9 = "row-start-9";

export const rowStart_rowStart10 = "row-start-10";

export const rowStart_rowStart11 = "row-start-11";

export const rowStart_rowStart12 = "row-start-12";

export const rowStart_rowStart13 = "row-start-13";

export const rowEnd_rowEndAuto = "row-end-auto";

export const rowEnd_rowEnd1 = "row-end-1";

export const rowEnd_rowEnd2 = "row-end-2";

export const rowEnd_rowEnd3 = "row-end-3";

export const rowEnd_rowEnd4 = "row-end-4";

export const rowEnd_rowEnd5 = "row-end-5";

export const rowEnd_rowEnd6 = "row-end-6";

export const rowEnd_rowEnd7 = "row-end-7";

export const rowEnd_rowEnd8 = "row-end-8";

export const rowEnd_rowEnd9 = "row-end-9";

export const rowEnd_rowEnd10 = "row-end-10";

export const rowEnd_rowEnd11 = "row-end-11";

export const rowEnd_rowEnd12 = "row-end-12";

export const rowEnd_rowEnd13 = "row-end-13";

export const backgroundAttachment_bgFixed = "bg-fixed";

export const backgroundAttachment_bgLocal = "bg-local";

export const backgroundAttachment_bgScroll = "bg-scroll";

export const backgroundClip_bgClipBorder = "bg-clip-border";

export const backgroundClip_bgClipPadding = "bg-clip-padding";

export const backgroundClip_bgClipContent = "bg-clip-content";

export const backgroundClip_bgClipText = "bg-clip-text";

export const backgroundOrigin_bgOriginBorder = "bg-origin-border";

export const backgroundOrigin_bgOriginPadding = "bg-origin-padding";

export const backgroundOrigin_bgOriginContent = "bg-origin-content";

export const backgroundPosition_bgBottom = "bg-bottom";

export const backgroundPosition_bgCenter = "bg-center";

export const backgroundPosition_bgLeft = "bg-left";

export const backgroundPosition_bgLeftBottom = "bg-left-bottom";

export const backgroundPosition_bgLeftTop = "bg-left-top";

export const backgroundPosition_bgRight = "bg-right";

export const backgroundPosition_bgRightBottom = "bg-right-bottom";

export const backgroundPosition_bgRightTop = "bg-right-top";

export const backgroundPosition_bgTop = "bg-top";

export const backgroundRepeat_bgRepeat = "bg-repeat";

export const backgroundRepeat_bgNoRepeat = "bg-no-repeat";

export const backgroundRepeat_bgRepeatX = "bg-repeat-x";

export const backgroundRepeat_bgRepeatY = "bg-repeat-y";

export const backgroundRepeat_bgRepeatRound = "bg-repeat-round";

export const backgroundRepeat_bgRepeatSpace = "bg-repeat-space";

export const backgroundSize_bgAuto = "bg-auto";

export const backgroundSize_bgCover = "bg-cover";

export const backgroundSize_bgContain = "bg-contain";

export const backgroundImage_bgNone = "bg-none";

export const backgroundImage_bgGradientToT = "bg-gradient-to-t";

export const backgroundImage_bgGradientToTr = "bg-gradient-to-tr";

export const backgroundImage_bgGradientToR = "bg-gradient-to-r";

export const backgroundImage_bgGradientToBr = "bg-gradient-to-br";

export const backgroundImage_bgGradientToB = "bg-gradient-to-b";

export const backgroundImage_bgGradientToBl = "bg-gradient-to-bl";

export const backgroundImage_bgGradientToL = "bg-gradient-to-l";

export const backgroundImage_bgGradientToTl = "bg-gradient-to-tl";

export const gradientColorStops_fromInherit = "from-inherit";

export const gradientColorStops_fromCurrent = "from-current";

export const gradientColorStops_fromTransparent = "from-transparent";

export const gradientColorStops_fromBlack = "from-black";

export const gradientColorStops_fromWhite = "from-white";

export const gradientColorStops_fromSlate50 = "from-slate-50";

export const gradientColorStops_fromSlate100 = "from-slate-100";

export const gradientColorStops_fromSlate200 = "from-slate-200";

export const gradientColorStops_fromSlate300 = "from-slate-300";

export const gradientColorStops_fromSlate400 = "from-slate-400";

export const gradientColorStops_fromSlate500 = "from-slate-500";

export const gradientColorStops_fromSlate600 = "from-slate-600";

export const gradientColorStops_fromSlate700 = "from-slate-700";

export const gradientColorStops_fromSlate800 = "from-slate-800";

export const gradientColorStops_fromSlate900 = "from-slate-900";

export const gradientColorStops_fromBlue500 = "from-blue-500";

export const gradientColorStops_fromRed500 = "from-red-500";

export const gradientColorStops_fromGreen500 = "from-green-500";

export const gradientColorStops_fromYellow500 = "from-yellow-500";

export const gradientColorStops_fromPurple500 = "from-purple-500";

export const gradientColorStops_fromPink500 = "from-pink-500";

export const gradientColorStops_viaInherit = "via-inherit";

export const gradientColorStops_viaCurrent = "via-current";

export const gradientColorStops_viaTransparent = "via-transparent";

export const gradientColorStops_viaBlack = "via-black";

export const gradientColorStops_viaWhite = "via-white";

export const gradientColorStops_viaSlate500 = "via-slate-500";

export const gradientColorStops_viaBlue500 = "via-blue-500";

export const gradientColorStops_viaRed500 = "via-red-500";

export const gradientColorStops_viaGreen500 = "via-green-500";

export const gradientColorStops_viaPurple500 = "via-purple-500";

export const gradientColorStops_toInherit = "to-inherit";

export const gradientColorStops_toCurrent = "to-current";

export const gradientColorStops_toTransparent = "to-transparent";

export const gradientColorStops_toBlack = "to-black";

export const gradientColorStops_toWhite = "to-white";

export const gradientColorStops_toSlate50 = "to-slate-50";

export const gradientColorStops_toSlate100 = "to-slate-100";

export const gradientColorStops_toSlate200 = "to-slate-200";

export const gradientColorStops_toSlate300 = "to-slate-300";

export const gradientColorStops_toSlate400 = "to-slate-400";

export const gradientColorStops_toSlate500 = "to-slate-500";

export const gradientColorStops_toSlate600 = "to-slate-600";

export const gradientColorStops_toSlate700 = "to-slate-700";

export const gradientColorStops_toSlate800 = "to-slate-800";

export const gradientColorStops_toSlate900 = "to-slate-900";

export const gradientColorStops_toBlue500 = "to-blue-500";

export const gradientColorStops_toRed500 = "to-red-500";

export const gradientColorStops_toGreen500 = "to-green-500";

export const gradientColorStops_toYellow500 = "to-yellow-500";

export const gradientColorStops_toPurple500 = "to-purple-500";

export const gradientColorStops_toPink500 = "to-pink-500";

export const mixBlendMode_mixBlendNormal = "mix-blend-normal";

export const mixBlendMode_mixBlendMultiply = "mix-blend-multiply";

export const mixBlendMode_mixBlendScreen = "mix-blend-screen";

export const mixBlendMode_mixBlendOverlay = "mix-blend-overlay";

export const mixBlendMode_mixBlendDarken = "mix-blend-darken";

export const mixBlendMode_mixBlendLighten = "mix-blend-lighten";

export const mixBlendMode_mixBlendColorDodge = "mix-blend-color-dodge";

export const mixBlendMode_mixBlendColorBurn = "mix-blend-color-burn";

export const mixBlendMode_mixBlendHardLight = "mix-blend-hard-light";

export const mixBlendMode_mixBlendSoftLight = "mix-blend-soft-light";

export const mixBlendMode_mixBlendDifference = "mix-blend-difference";

export const mixBlendMode_mixBlendExclusion = "mix-blend-exclusion";

export const mixBlendMode_mixBlendHue = "mix-blend-hue";

export const mixBlendMode_mixBlendSaturation = "mix-blend-saturation";

export const mixBlendMode_mixBlendColor = "mix-blend-color";

export const mixBlendMode_mixBlendLuminosity = "mix-blend-luminosity";

export const mixBlendMode_mixBlendPlusDarker = "mix-blend-plus-darker";

export const mixBlendMode_mixBlendPlusLighter = "mix-blend-plus-lighter";

export const backgroundBlendMode_bgBlendNormal = "bg-blend-normal";

export const backgroundBlendMode_bgBlendMultiply = "bg-blend-multiply";

export const backgroundBlendMode_bgBlendScreen = "bg-blend-screen";

export const backgroundBlendMode_bgBlendOverlay = "bg-blend-overlay";

export const backgroundBlendMode_bgBlendDarken = "bg-blend-darken";

export const backgroundBlendMode_bgBlendLighten = "bg-blend-lighten";

export const backgroundBlendMode_bgBlendColorDodge = "bg-blend-color-dodge";

export const backgroundBlendMode_bgBlendColorBurn = "bg-blend-color-burn";

export const backgroundBlendMode_bgBlendHardLight = "bg-blend-hard-light";

export const backgroundBlendMode_bgBlendSoftLight = "bg-blend-soft-light";

export const backgroundBlendMode_bgBlendDifference = "bg-blend-difference";

export const backgroundBlendMode_bgBlendExclusion = "bg-blend-exclusion";

export const backgroundBlendMode_bgBlendHue = "bg-blend-hue";

export const backgroundBlendMode_bgBlendSaturation = "bg-blend-saturation";

export const backgroundBlendMode_bgBlendColor = "bg-blend-color";

export const backgroundBlendMode_bgBlendLuminosity = "bg-blend-luminosity";

export const screenReaders_srOnly = "sr-only";

export const screenReaders_notSrOnly = "not-sr-only";

export const forcedColorAdjust_forcedColorAdjustAuto = "forced-color-adjust-auto";

export const forcedColorAdjust_forcedColorAdjustNone = "forced-color-adjust-none";

//# sourceMappingURL=Strings.fs.js.map
